/* eslint-disable */
/* GENERATED FILE - DO NOT MODIFY */
/* run yarn import-data to regenerate */
import { GridProduct, SkinProduct, MechProduct, InterfaceProduct, ProductRule, ConstantProductsShape } from "../types/productTypes"

const GridProducts: readonly GridProduct[] = 
[
  {
    "itemNo": "3043USBG",
    "description": "Clipsal Iconic USB Charger Grid and Module",
    "displayName": "",
    "comparisonName": "",
    "type": "Other",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3043USBG"
  },
  {
    "itemNo": "3043HSUSB-VW",
    "description": "Clipsal Iconic USB Charging Station with Shelf, 3 Outlet, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Other",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3043HS-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3043USBG"
  },
  {
    "itemNo": "3015/15G",
    "description": "Clipsal Iconic Single Switch Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/15G"
  },
  {
    "itemNo": "3015/20G",
    "description": "Clipsal Iconic Single Power Point Grid, Horizontal Mount, 250V, 20A",
    "displayName": "",
    "comparisonName": "20A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/20G"
  },
  {
    "itemNo": "3015G",
    "description": "Clipsal Iconic Single Switch Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "3015VG",
    "slotPositions": [],
    "baseItemNo": "3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015G"
  },
  {
    "itemNo": "3015-VW",
    "description": "Clipsal Iconic Single Switch Power Point, Horizontal Mount, 250 V, 10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "3015VG",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015G"
  },
  {
    "itemNo": "3015-XW",
    "description": "Clipsal Iconic Single Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "3015VG",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015C-XW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015G"
  },
  {
    "itemNo": "3015/15-VW",
    "description": "Clipsal Iconic Single Switch Power Point, Horizontal Mount, 250 V, 15 A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015/15C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/15G"
  },
  {
    "itemNo": "3015/20-VW",
    "description": "Clipsal Iconic Single Switch Power Point, Horizontal Mount, 250V, 20A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015/20C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/20G"
  },
  {
    "itemNo": "3015/4XXUAG",
    "description": "Clipsal Iconic Quad Switch Power Point Grid with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/4XXUAG"
  },
  {
    "itemNo": "3015/4XXUA-VW",
    "description": "Clipsal Iconic Quad Switch Power Point with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3015/4XXC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015/4XXUAG"
  },
  {
    "itemNo": "3015/4-VW",
    "description": "Clipsal Iconic Quad Switch Power Point, Horizontal Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015/4C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3015VG",
    "description": "Clipsal Iconic Single Switch Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "3015G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015VG"
  },
  {
    "itemNo": "3015V-VW",
    "description": "Clipsal Iconic Single Switch Power Point, Vertical Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "3015G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3015VC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015VG"
  },
  {
    "itemNo": "3025/15G",
    "description": "Clipsal Iconic Double Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025/15G"
  },
  {
    "itemNo": "3025/15-VW",
    "description": "Clipsal Iconic Double Power Point, Horizontal Mount, 15A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3025/15C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025/15G"
  },
  {
    "itemNo": "3025CSGZ",
    "description": "Iconic Connected Socket, Zigbee Default Mode Twin Horizontal, 10 A, 240 V, Grid",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3025G",
    "description": "Clipsal Iconic Double Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "3025VXA-VW",
    "slotPositions": [],
    "baseItemNo": "3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025G"
  },
  {
    "itemNo": "3025-VW",
    "description": "Clipsal Iconic Double Switch Power Point, Horizontal Mount, 250V, 10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "3025VXA-VW",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3025C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025G"
  },
  {
    "itemNo": "3025-XW",
    "description": "Clipsal Iconic Double Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3025C-XW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025G"
  },
  {
    "itemNo": "3025VXUAG",
    "description": "Clipsal Iconic Double Switch Power Point Grid with 1 extra switch, Vertical Mount, 250V,10A, less Mechanism",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "3025XAG",
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025VXUAG"
  },
  {
    "itemNo": "3040G",
    "description": "Clipsal Iconic Switch Blank Grid Plate, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 0,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3040G"
  },
  {
    "itemNo": "3040-VW",
    "description": "Clipsal Iconic Blank Switch Plate, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Other",
    "gangNo": 0,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3040C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3040G"
  },
  {
    "itemNo": "3041G",
    "description": "Clipsal Iconic Switch Grid, 1 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3042G",
    "description": "Clipsal Iconic Switch Grid, 2 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3043G",
    "description": "Clipsal Iconic Switch Grid, 3 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3044G",
    "description": "Clipsal Iconic Switch Grid, 4 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3045G",
    "description": "Clipsal Iconic Switch Grid, 5 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3045G"
  },
  {
    "itemNo": "3046G",
    "description": "Clipsal Iconic Switch Grid, 6 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 41,
        "y": 50
      },
      {
        "x": 59.4,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3046G"
  },
  {
    "itemNo": "3041VAG",
    "description": "Clipsal Iconic Gridplate and Mechanism 1 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": 0,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3042VAG",
    "description": "Clipsal Iconic Gridplate and Mechanism 2 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": 0,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3043VAG",
    "description": "Clipsal Iconic Gridplate and Mechanism 3 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": 0,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3044VAG",
    "description": "Clipsal Iconic Gridplate and Mechanism 4 Gang, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": 0,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3041/45-VW",
    "description": "Clipsal Iconic Cooking Appliance Isolator Switch and Skin, Horizontal/Vertical Mount, Single Pole, 250V, 45A, Vivid White",
    "displayName": "",
    "comparisonName": "Single Pole",
    "type": "Other",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3041/45",
    "includedSkinItemNo": "3041/45C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3041D45-VW",
    "description": "Clipsal Iconic Cooking Appliance Isolator Switch and Skin, Horizontal/Vertical Mount, Double Pole, 250V, 45A, Vivid White",
    "displayName": "",
    "comparisonName": "Double Pole",
    "type": "Other",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "3041/45",
    "includedSkinItemNo": "3041D45-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3041AL-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 1 Gang, Architrave, 250V, 10AX, LED, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041AC-VW",
    "includedMechItemNo": "40ML",
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3042AL-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 2 Gang, Architrave, 250V, 10AX, LED, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042AC-VW",
    "includedMechItemNo": "40ML",
    "pro": false,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "P3041A-XW",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3041A-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "P3042A-XW",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3042A-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "P3041A-BK",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3041A-BK",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "P3042A-BK",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3042A-BK",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "3041VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 1 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "3041HA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3041HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 1 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "3041VA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3041VA-XW",
    "description": "Clipsal Iconic Flush Switch, 1 Gang, Vertical Mount, 1-Way/2-Way, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "3041HA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041C-XW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3041VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 1 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": "P3044VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3041VH-XW",
    "description": "Clipsal Iconic Gridplate and Skin, 1 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": "P3044VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3041C-XW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3041G"
  },
  {
    "itemNo": "3042VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 2 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Vertical",
    "otherOrientation": "3042HA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3042HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 2 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": "3042VA-VW",
    "slotPositions": [
      {
        "x": 37.3,
        "y": 50
      },
      {
        "x": 62.7,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3042VA-XW",
    "description": "Clipsal Iconic Flush Switch, 2 Gang, Vertical Mount, 1-Way/2-Way, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042C-XW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3042VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 2 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3042VH-XW",
    "description": "Clipsal Iconic Gridplate and Skin, 2 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3042C-XW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3042G"
  },
  {
    "itemNo": "3043VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 3 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Vertical",
    "otherOrientation": "3043HA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3043C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3043HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 3 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Horizontal",
    "otherOrientation": "3043VA-VW",
    "slotPositions": [
      {
        "x": 32.4,
        "y": 50
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 67.6,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3043C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3043VA-XW",
    "description": "Clipsal Iconic Flush Switch, 3 Gang, Vertical Mount, 1-Way/2-Way, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3043C-XW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3043VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 3 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3043C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3043G"
  },
  {
    "itemNo": "3044VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 4 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Vertical",
    "otherOrientation": "3044HA-VW",
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3044C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3044HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 4 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Horizontal",
    "otherOrientation": "3044VA-VW",
    "slotPositions": [
      {
        "x": 38.7,
        "y": 41
      },
      {
        "x": 38.7,
        "y": 59
      },
      {
        "x": 62.3,
        "y": 41
      },
      {
        "x": 62.3,
        "y": 59
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3044C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3044VA-XW",
    "description": "Clipsal Iconic Flush Switch, 4 Gang, Vertical Mount, 1-Way/2-Way, 250V, 10AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3044C-XW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3044VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 4 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": "3044HA-VW",
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3044C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3044G"
  },
  {
    "itemNo": "3045VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 5 Gang, 250V, 10AX, 1-Way/2-Way, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Vertical",
    "otherOrientation": "3045HA-VW",
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3045C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3045G"
  },
  {
    "itemNo": "3045HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 5 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Horizontal",
    "otherOrientation": "3045VA-VW",
    "slotPositions": [
      {
        "x": 32,
        "y": 41
      },
      {
        "x": 32,
        "y": 59.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 68.3,
        "y": 41
      },
      {
        "x": 68.3,
        "y": 59.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3045C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3045G"
  },
  {
    "itemNo": "3045VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 5 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Vertical",
    "otherOrientation": "3045HA-VW",
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3045C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3045G"
  },
  {
    "itemNo": "3046VA-VW",
    "description": "Clipsal Iconic Flush Switch, Vertical Mount, 6 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Vertical",
    "otherOrientation": "3046HA-VW",
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 41,
        "y": 50
      },
      {
        "x": 59.4,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3046C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3046G"
  },
  {
    "itemNo": "3046HA-VW",
    "description": "Clipsal Iconic Flush Switch, Horizontal Mount, 6 Gang, 1-Way/2-Way, 250V, 10AX, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Horizontal",
    "otherOrientation": "3046VA-VW",
    "slotPositions": [
      {
        "x": 32,
        "y": 41
      },
      {
        "x": 32,
        "y": 59.4
      },
      {
        "x": 50,
        "y": 41
      },
      {
        "x": 50,
        "y": 59.4
      },
      {
        "x": 68.3,
        "y": 41
      },
      {
        "x": 68.3,
        "y": 59.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3046C-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3046G"
  },
  {
    "itemNo": "3046VH-VW",
    "description": "Clipsal Iconic Gridplate and Skin, 6 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 41,
        "y": 50
      },
      {
        "x": 59.4,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3046C-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3046G"
  },
  {
    "itemNo": "3015XUAG",
    "description": "Clipsal Iconic Single Power Point Grid, Horizontal Mount, 1ExBlank, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3015XUAG"
  },
  {
    "itemNo": "3015XA-VW",
    "description": "Clipsal Iconic Single Power Point, Horizontal Mount, 1Ex10AX, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3015XC-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3015XUAG"
  },
  {
    "itemNo": "3025XAG",
    "description": "Clipsal Iconic Double Switch Power Point Grid with 1 extra switch, Horizontal Mount, 250V,10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "3025VXUAG",
    "slotPositions": [
      {
        "x": 50,
        "y": 42.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025XAG"
  },
  {
    "itemNo": "3025XA-VW",
    "description": "Clipsal Iconic Double Switch Power Point, Horizontal Mount, 250 V, 10A, Extra Removable Switch",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "3025VXA-VW",
    "slotPositions": [
      {
        "x": 50,
        "y": 42.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3025XC-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3025XAG"
  },
  {
    "itemNo": "3025XUA-VW",
    "description": "Clipsal Iconic Double Switch Power Point, Horizontal Mount, 250 V, 10A, Removable Extra Switch, Less Mechanism",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "3025VXUAG",
    "slotPositions": [
      {
        "x": 50,
        "y": 42.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3025XC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025XAG"
  },
  {
    "itemNo": "3025VXA-VW",
    "description": "Clipsal Iconic Double Switch Power Point, Vertical Mount, 250 V, 10 A with Removable Extra Switch, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "3025XA-VW",
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "3025VXC-VW",
    "includedMechItemNo": "40M",
    "pro": false,
    "standaloneGridItemNo": "3025VXUAG"
  },
  {
    "itemNo": "3025V-VW",
    "description": "Clipsal Iconic Twin Switch Power Point, Vertical Mount, 250V,10A, Vivid White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "3025XA-VW",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "3025VC-VW",
    "includedMechItemNo": null,
    "pro": false,
    "standaloneGridItemNo": "3025VXUAG"
  },
  {
    "itemNo": "P3015G",
    "description": "Clipsal Pro Single Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015G"
  },
  {
    "itemNo": "P3015-XW",
    "description": "Clipsal Pro Single Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015G"
  },
  {
    "itemNo": "P3015-15G",
    "description": "Clipsal Pro Single Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-15G"
  },
  {
    "itemNo": "P3015-15-XW",
    "description": "Clipsal Pro Single Power Point, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015-15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-15G"
  },
  {
    "itemNo": "P3015-20G",
    "description": "Clipsal Pro Single Power Point Grid, Horizontal Mount, 250V, 20A",
    "displayName": "",
    "comparisonName": "20A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-20G"
  },
  {
    "itemNo": "P3015-20-XW",
    "description": "Clipsal Pro Single Power Point, Horizontal Mount, 250V, 20A, White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015-20C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-20G"
  },
  {
    "itemNo": "P3015-4XXUAG",
    "description": "Clipsal Pro Quad Power Point Grid with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-4XXUAG"
  },
  {
    "itemNo": "P3015-4XXUA-XW",
    "description": "Clipsal Pro Quad Power Point with 2 extra switches, Horizontal Mount, 250V, 10A, Less Mechanisms",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 4,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 28,
        "y": 44.4
      },
      {
        "x": 72,
        "y": 44.4
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015-4XXC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-4XXUAG"
  },
  {
    "itemNo": "P3015-4G",
    "description": "Clipsal Pro Quad Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-4G"
  },
  {
    "itemNo": "P3015-4-XW",
    "description": "Clipsal Pro Quad Power Point, Horizontal Mount, 250V,10A, White",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015-4C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015-4G"
  },
  {
    "itemNo": "P3015VG",
    "description": "Clipsal Pro Single Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015VG",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015VG"
  },
  {
    "itemNo": "P3015V-XW",
    "description": "Clipsal Pro Single Power Point, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015VC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015VG"
  },
  {
    "itemNo": "P3015V15G",
    "description": "Clipsal Pro Single Power Point Grid, Vertical Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015VG",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015V15G"
  },
  {
    "itemNo": "P3015V15-XW",
    "description": "Clipsal Pro Single Power Point, Vertical Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015V15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015V15G"
  },
  {
    "itemNo": "P3015XAG",
    "description": "Clipsal Pro Single Power Point Grid, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015XAG"
  },
  {
    "itemNo": "P3015XA-XW",
    "description": "Clipsal Pro Single Power Point, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 30.1,
        "y": 49.8
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3015XC-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3015XAG"
  },
  {
    "itemNo": "P3025G",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "P3025VG",
    "slotPositions": [],
    "baseItemNo": "P3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025G"
  },
  {
    "itemNo": "P3025-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "P3025VG",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025G"
  },
  {
    "itemNo": "P3025D-XW",
    "description": "Clipsal Pro Twin Power Point, Double Pole, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": "P3025VG",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025D-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025D-XW"
  },
  {
    "itemNo": "P3025-15G",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3025G",
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025-15G"
  },
  {
    "itemNo": "P3025-15-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025-15C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025-15G"
  },
  {
    "itemNo": "P3025LG",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, Round Earth, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025LG"
  },
  {
    "itemNo": "P3025L-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, Round Earth, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025LC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025LG"
  },
  {
    "itemNo": "P3025PIDG",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, Power Indicator, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025PIDG"
  },
  {
    "itemNo": "P3025PID-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, Power Indicator, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025PIDC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025PIDG"
  },
  {
    "itemNo": "P3015D-XW",
    "description": "Clipsal Pro Single Power Point, Double Pole, Horizontal Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "10A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015D",
    "includedSkinItemNo": "P3015D-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015D-XW"
  },
  {
    "itemNo": "P3015D15-XW",
    "description": "Clipsal Pro Single Power Point, Double Pole, Horizontal Mount, 250V, 15A",
    "displayName": "",
    "comparisonName": "15A",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 1,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": "P3015D",
    "includedSkinItemNo": "P3015D15-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3015D15-XW"
  },
  {
    "itemNo": "P3025USB2G",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, 1Ex2USBCHRG, Type A+A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025USB2G"
  },
  {
    "itemNo": "P3025USB2-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025USB2-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025USB2G"
  },
  {
    "itemNo": "P3025USBAC-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+C, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025USBAC-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": null
  },
  {
    "itemNo": "P3025VG",
    "description": "Clipsal Pro Twin Power Point Grid, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": "P3025G",
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025VG"
  },
  {
    "itemNo": "P3025VXAG",
    "description": "Clipsal Pro Twin Power Point Grid, Vertical Mount, 1Ex20A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3025VXAG"
  },
  {
    "itemNo": "P3025VXA-XW",
    "description": "Clipsal Pro Twin Power Point, Vertical Mount, 1Ex20A, 10A, 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39.3,
        "y": 49.1
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025VXC-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3025VXAG"
  },
  {
    "itemNo": "P3025V-XW",
    "description": "Clipsal Pro Twin Power Point, Vertical Mount, 250V, 10A",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 0,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025V-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3025VG"
  },
  {
    "itemNo": "P3025XAG",
    "description": "Clipsal Pro Twin Power Point Grid, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": 2,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 49.6,
        "y": 41.9
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3025XAG"
  },
  {
    "itemNo": "P3041G",
    "description": "Clipsal Pro Switch Grid, 1 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3041G"
  },
  {
    "itemNo": "P3042G",
    "description": "Clipsal Pro Switch Grid, 2 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3042G"
  },
  {
    "itemNo": "P3043G",
    "description": "Clipsal Pro Switch Grid, 3 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3043G"
  },
  {
    "itemNo": "P3044G",
    "description": "Clipsal Pro Switch Grid, 4 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3044G"
  },
  {
    "itemNo": "P3045G",
    "description": "Clipsal Pro Switch Grid, 5 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3045G"
  },
  {
    "itemNo": "P3046G",
    "description": "Clipsal Pro Switch Grid, 6 Gang, Horizontal/Vertical Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39,
        "y": 30
      },
      {
        "x": 59,
        "y": 30
      },
      {
        "x": 39,
        "y": 50
      },
      {
        "x": 59,
        "y": 50
      },
      {
        "x": 39,
        "y": 70
      },
      {
        "x": 59,
        "y": 70
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": null,
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3046G"
  },
  {
    "itemNo": "P3025XA-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 1Ex20A 10A 250V",
    "displayName": "",
    "comparisonName": "",
    "type": "Socket",
    "gangNo": null,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 49.6,
        "y": 41.9
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3025XC-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3025XAG"
  },
  {
    "itemNo": "P3041VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 1 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Vertical",
    "otherOrientation": "P3041HA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3041C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3041G"
  },
  {
    "itemNo": "P3041HA-XW",
    "description": "Clipsal Pro Flush Switch, Horizontal Mount, 1 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Horizontal",
    "otherOrientation": "P3041VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3041C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3041G"
  },
  {
    "itemNo": "P3041VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 1 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 1,
    "socketNo": null,
    "slotCount": 1,
    "orientation": "Both",
    "otherOrientation": "P3044VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3041C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3041G"
  },
  {
    "itemNo": "P3042VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 2 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Vertical",
    "otherOrientation": "P3042HA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3042C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3042G"
  },
  {
    "itemNo": "P3042HA-XW",
    "description": "Clipsal Pro Flush Switch, Horizontal Mount, 2 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Horizontal",
    "otherOrientation": "P3042VA-XW",
    "slotPositions": [
      {
        "x": 37.3,
        "y": 50
      },
      {
        "x": 62.7,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3042C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3042G"
  },
  {
    "itemNo": "P3042VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 2 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 2,
    "socketNo": null,
    "slotCount": 2,
    "orientation": "Both",
    "otherOrientation": "P3042VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 37.3
      },
      {
        "x": 50,
        "y": 62.7
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3042C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3042G"
  },
  {
    "itemNo": "P3043VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 3 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Vertical",
    "otherOrientation": "P3043HA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3043C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3043G"
  },
  {
    "itemNo": "P3043HA-XW",
    "description": "Clipsal Pro Flush Switch, Horizontal Mount, 3 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Horizontal",
    "otherOrientation": "P3043VA-XW",
    "slotPositions": [
      {
        "x": 32.4,
        "y": 50
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 67.6,
        "y": 50
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3043C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3043G"
  },
  {
    "itemNo": "P3043VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 3 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 3,
    "socketNo": null,
    "slotCount": 3,
    "orientation": "Both",
    "otherOrientation": "P3043VA-XW",
    "slotPositions": [
      {
        "x": 50,
        "y": 32.4
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 50,
        "y": 67.6
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3043C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3043G"
  },
  {
    "itemNo": "P3044VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 4 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Vertical",
    "otherOrientation": "P3044HA-XW",
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3044C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3044G"
  },
  {
    "itemNo": "P3044HA-XW",
    "description": "Clipsal Pro Flush Switch, Horizontal Mount, 4 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Horizontal",
    "otherOrientation": "P3044VA-XW",
    "slotPositions": [
      {
        "x": 38.7,
        "y": 41
      },
      {
        "x": 38.7,
        "y": 59
      },
      {
        "x": 62.3,
        "y": 41
      },
      {
        "x": 62.3,
        "y": 59
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3044C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3044G"
  },
  {
    "itemNo": "P3044VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 4 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 4,
    "socketNo": null,
    "slotCount": 4,
    "orientation": "Both",
    "otherOrientation": "P3044VA-XW",
    "slotPositions": [
      {
        "x": 41,
        "y": 38.7
      },
      {
        "x": 59,
        "y": 38.7
      },
      {
        "x": 41,
        "y": 62.3
      },
      {
        "x": 59,
        "y": 62.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3044C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3044G"
  },
  {
    "itemNo": "P3045VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 5 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3045C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3045G"
  },
  {
    "itemNo": "P3045VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 5 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 5,
    "socketNo": null,
    "slotCount": 5,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 41,
        "y": 32
      },
      {
        "x": 59.4,
        "y": 32
      },
      {
        "x": 50,
        "y": 50
      },
      {
        "x": 41,
        "y": 68.3
      },
      {
        "x": 59.4,
        "y": 68.3
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3045C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3045G"
  },
  {
    "itemNo": "P3046VA-XW",
    "description": "Clipsal Pro Flush Switch, Vertical Mount, 6 Gang, 1-Way/2-Way, 250V, 20A/16AX",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Vertical",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39,
        "y": 30
      },
      {
        "x": 59,
        "y": 30
      },
      {
        "x": 39,
        "y": 50
      },
      {
        "x": 59,
        "y": 50
      },
      {
        "x": 39,
        "y": 70
      },
      {
        "x": 59,
        "y": 70
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3046C-XW",
    "includedMechItemNo": "40USM",
    "pro": true,
    "standaloneGridItemNo": "P3046G"
  },
  {
    "itemNo": "P3046VH-XW",
    "description": "Clipsal Pro Gridplate and Skin, 6 Gang, Vertical/Horizontal Mount",
    "displayName": "",
    "comparisonName": "",
    "type": "Switch",
    "gangNo": 6,
    "socketNo": null,
    "slotCount": 6,
    "orientation": "Both",
    "otherOrientation": null,
    "slotPositions": [
      {
        "x": 39,
        "y": 30
      },
      {
        "x": 59,
        "y": 30
      },
      {
        "x": 39,
        "y": 50
      },
      {
        "x": 59,
        "y": 50
      },
      {
        "x": 39,
        "y": 70
      },
      {
        "x": 59,
        "y": 70
      }
    ],
    "baseItemNo": null,
    "includedSkinItemNo": "P3046C-XW",
    "includedMechItemNo": null,
    "pro": true,
    "standaloneGridItemNo": "P3046G"
  }
]

const SkinProducts: readonly SkinProduct[] = 
[
  {
    "itemNo": "3015/15C-AN",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Anthracite",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/15G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/15C-CY",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Cool Grey",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/15G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/15C-VW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Vivid White",
    "displayName": "Single Power Point 15Amp",
    "image": "3015_15C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/15G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/20C-AN",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Anthracite",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/20G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/20C-CY",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Cool Grey",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/20G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/20C-VW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Vivid White",
    "displayName": "Single Power Point 20Amp",
    "image": "3015_20C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015/20G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4C-AN",
    "description": "Clipsal Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On,Anthracite",
    "displayName": "Quad Power Point",
    "image": "3015_4-AN.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4C-CY",
    "description": "Clipsal Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Quad Power Point",
    "image": "3015_4-CY.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4C-VW",
    "description": "Clipsal Iconic Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Quad Power Point",
    "image": "3015_4C-VW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4C-XW",
    "description": "Clipsal Iconic Quad Switch Power Point, Horizontal Mount, 250V,10A, Extra White",
    "displayName": "Quad Power Point",
    "image": "3015_4C-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015-4C-XB",
    "description": "Skin Socket Sw Horiz Quad 10A 250V XB",
    "displayName": "Quad Power Point",
    "image": "3015-4C-XB.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4XXC-AN",
    "description": "Clipsal Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-AN.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4XXC-CY",
    "description": "Clipsal Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-CY.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4XXC-VW",
    "description": "Clipsal Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-VW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015/4XXC-XW",
    "description": "Clipsal Iconic Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015_4XXC-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015-4XXC-XB",
    "description": "Skin Socket SwHorizQuad 2ExSw 10A 250V XB",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "3015-4XXC-XB.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015C-AN",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Single Power Point",
    "image": "3015C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3015VC-AN"
  },
  {
    "itemNo": "3015C-CY",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Single Power Point",
    "image": "3015C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3015VC-CY"
  },
  {
    "itemNo": "3015C-VW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Single Power Point",
    "image": "3015C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3015VC-VW"
  },
  {
    "itemNo": "3015C-XB",
    "description": "Skin Socket Horiz Single 10A 250V XB",
    "displayName": "Single Power Point",
    "image": "3015C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3015VC-XB"
  },
  {
    "itemNo": "3015C-XW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Single Power Point",
    "image": "3015C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015VC-AN",
    "description": "Clipsal Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical Single Power Point",
    "image": "3015V-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3015VG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3015C-AN"
  },
  {
    "itemNo": "3015VC-CY",
    "description": "Clipsal Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3015VG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3015C-CY"
  },
  {
    "itemNo": "3015VC-VW",
    "description": "Clipsal Iconic Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On,Vivid White",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3015VG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3015C-VW"
  },
  {
    "itemNo": "3015VC-XB",
    "description": "Skin Socket Sw Vert Single 10A 250V XB",
    "displayName": "Vertical Single Power Point",
    "image": "3015VC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3015VG",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3015C-XB"
  },
  {
    "itemNo": "3015XC-AN",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Anthracite",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015XC-CY",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Cool Grey",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015XC-VW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Vivid White",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015XC-XB",
    "description": "Skin Socket Sw Horiz Sgl 1ExSw XB",
    "displayName": "Single Power Point with Extra switch",
    "image": "3015XC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3015XC-XW",
    "description": "Clipsal Iconic Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V Clip-On, Extra White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "3015XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025/15C-AN",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Anthracite",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025/15G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025/15C-CY",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Cool Grey",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025/15G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025/15C-VW",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 15A, 250V, Clip-On, Vivid White",
    "displayName": "Double Power Point 15Amp",
    "image": "3025_15C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025/15G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025C-AN",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Double Power Point",
    "image": "3025C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VC-AN"
  },
  {
    "itemNo": "3025C-CY",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Double Power Point",
    "image": "3025C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VC-CY"
  },
  {
    "itemNo": "3025C-VW",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Double Power Point",
    "image": "3025C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VC-VW"
  },
  {
    "itemNo": "3025C-XB",
    "description": "Skin Socket Sw Horiz Twin 10A 250V XB",
    "displayName": "Double Power Point",
    "image": "3025C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VC-XB"
  },
  {
    "itemNo": "3025C-XW",
    "description": "Clipsal Iconic Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Double Power Point",
    "image": "3025C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025CSC-AN",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, VW",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "3025CSC-CY",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, CY",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "3025CSC-VW",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic, VW",
    "displayName": "Wiser Connected Double Power Point",
    "image": "3025CSC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "3025VC-AN",
    "description": "Clipsal Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025V-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025C-AN"
  },
  {
    "itemNo": "3025VC-CY",
    "description": "Clipsal Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025V-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025C-CY"
  },
  {
    "itemNo": "3025VC-VW",
    "description": "Clipsal Iconic Double Power Point Skin, Vertical Mount, 250V, 10A, Clip-On,Vivid White",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025V-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025C-VW"
  },
  {
    "itemNo": "3025VC-XB",
    "description": "Skin Socket SwVert Twin 10A 250V XB",
    "displayName": "Vertical  Double Power Point  ",
    "image": "3025VC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025V-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": true,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025C-XB"
  },
  {
    "itemNo": "3025VXC-AN",
    "description": "Clipsal Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025VXA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025XC-AN"
  },
  {
    "itemNo": "3025VXC-CY",
    "description": "Clipsal Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025VXA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025XC-CY"
  },
  {
    "itemNo": "3025VXC-VW",
    "description": "Clipsal Iconic Double Power Point Skin with Extra Switch, Vertical Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025VXA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025XC-VW"
  },
  {
    "itemNo": "3025VXC-XB",
    "description": "Skin Socket SwVertTwin 1ExSw XB",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "3025VXC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3025VXA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": "3025XC-XB"
  },
  {
    "itemNo": "3025XC-AN",
    "description": "Clipsal Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Anthracite",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VXC-AN"
  },
  {
    "itemNo": "3025XC-CY",
    "description": "Clipsal Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Cool Grey",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VXC-CY"
  },
  {
    "itemNo": "3025XC-VW",
    "description": "Clipsal Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Vivid White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VXC-VW"
  },
  {
    "itemNo": "3025XC-XB",
    "description": "Skin Socket Sw Horiz Twin 1ExSW 10A 250V XB",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": "3025VXC-XB"
  },
  {
    "itemNo": "3025XC-XW",
    "description": "Clipsal Iconic Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Extra White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "3025XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015/4C-AG",
    "description": "Clipsal Iconic Essence Quad Power Point Skin, 250V, 10A, Horizontal, Clip-On, Ash Grey",
    "displayName": "Quad Power Point",
    "image": "E3015_4C-AG.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015/4C-AW",
    "description": "Clipsal Iconic Essence Quad Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Quad Power Point",
    "image": "E3015_4C-AW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015/4XXUAC-AG",
    "description": "Clipsal Iconic Essence Quad Power Point Skin with 2 extra switches, Horizontal Mount, , 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "E3015_4XXUAC-AG.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015/4XXUAC-AW",
    "description": "Clipsal Iconic Essence Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Arctic White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "E3015_4XXUAC-AW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015C-AG",
    "description": "Clipsal Iconic Essence Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Single Power Point",
    "image": "E3015C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015C-AW",
    "description": "Clipsal Iconic Essence Single Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Single Power Point",
    "image": "E3015C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015XC-AG",
    "description": "Clipsal Iconic Essence Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Single Power Point with Extra Switch",
    "image": "E3015XC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3015XC-AW",
    "description": "Clipsal Iconic Essence Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "E3015XC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3025C-AG",
    "description": "Clipsal Iconic Essence Double Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Double Power Point",
    "image": "E3025C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3025C-AW",
    "description": "Clipsal Iconic Essence Double Power Point Skin, Horizontal Mount, 250V, 10A, Arctic White",
    "displayName": "Double Power Point",
    "image": "E3025C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3025CSC-AG",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Essence, AG",
    "displayName": "Connected Double Power Point",
    "image": "E3025CSC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "E3025CSC-AW",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Essence, AW",
    "displayName": "Connected Double Power Point",
    "image": "E3025CSC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "E3025XC-AG",
    "description": "Clipsal Iconic Essence Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Clip-On, Ash Grey",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "E3025XC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3025XC-AW",
    "description": "Clipsal Iconic Essence Double Power Point Skin with 1 extra switch, HorizontalMount, 250V, 10A, Arctic White",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "E3025XC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4C-CE",
    "description": "Clipsal Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V 10A, Crowne",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-CE.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4C-SH",
    "description": "Clipsal Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-SH.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4C-SV",
    "description": "Clipsal Iconic Styl Quad Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Quad Power Point",
    "image": "S3015_4C-SV.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4XXUAC-CE",
    "description": "Clipsal Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount,250V, 10A, Crowne",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-CE.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4XXUAC-SH",
    "description": "Clipsal Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Silver Shadow",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-SH.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015/4XXUAC-SV",
    "description": "Clipsal Iconic Styl Quad Power Point Skin with 2 extra switches, Horizontal Mount, 10A, 250V, Silver",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "S3015_4XXUAC-SV.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "3015/4XXUAG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015C-CE",
    "description": "Clipsal Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Single Power Point",
    "image": "S3015C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015C-SH",
    "description": "Clipsal Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Single Power Point",
    "image": "S3015C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015C-SV",
    "description": "Clipsal Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Single Power Point",
    "image": "S3015C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015XC-CE",
    "description": "Clipsal Iconic Styl Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015XC-SH",
    "description": "Clipsal Iconic Styl Single Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3015XC-SV",
    "description": "Clipsal Iconic Styl Single Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Single Power Point with Extra Switch",
    "image": "S3015XC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3015XUAG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025C-CE",
    "description": "Clipsal Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Crowne",
    "displayName": "Double Power Point",
    "image": "S3025C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025C-SH",
    "description": "Clipsal Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Double Power Point",
    "image": "S3025C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025C-SV",
    "description": "Clipsal Iconic Styl Double Power Point Skin, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Double Power Point",
    "image": "S3025C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025CSC-CE",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, CE",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "S3025CSC-SH",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, SH",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "S3025CSC-SV",
    "description": "Skin, Wiser Connected Socket, Horizontal Twin, Iconic Styl, SV",
    "displayName": "Connected Double Power Point",
    "image": "S3025CSC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025CSGZ",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Socket",
      "Wiser"
    ],
    "displaySubcategory": "Power Points"
  },
  {
    "itemNo": "S3025XC-CE",
    "description": "Clipsal Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount,250V, 10A, Crowne",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025XC-SH",
    "description": "Clipsal Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver Shadow",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3025XC-SV",
    "description": "Clipsal Iconic Styl Double Power Point Skin with 1 extra switch, Horizontal Mount, 250V, 10A, Silver",
    "displayName": "Double Power Point with Extra Switch  ",
    "image": "S3025XC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025XA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3041AC-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Anthracite",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041AL-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041AC-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Cool Grey",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041AL-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041AC-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Architrave, Vertical Mount, Clip-On, Vivid White",
    "displayName": "Architrave 1 Switch",
    "image": "3041AC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041AL-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Anthracite",
    "displayName": "1 Switch ",
    "image": "3041C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Cool Grey",
    "displayName": "1 Switch ",
    "image": "3041C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Vivid White",
    "displayName": "1 Switch ",
    "image": "3041C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-XB",
    "description": "Skin Switch V/H 1G rocker XB",
    "displayName": "1 Switch ",
    "image": "3041C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3041C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "1 Switch ",
    "image": "3041C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042AC-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Anthracite",
    "displayName": "2 Switches",
    "image": "3042AC-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042AL-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042AC-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Cool Grey",
    "displayName": "2 Switches",
    "image": "3042AC-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042AL-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042AC-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Architrave, Vertical Mount, Clip-On, Vivid White",
    "displayName": "2 Switches",
    "image": "3042AC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042AL-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Anthracite",
    "displayName": "2 Switches",
    "image": "3042C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Cool Grey",
    "displayName": "2 Switches",
    "image": "3042C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Vivid White",
    "displayName": "2 Switches",
    "image": "3042C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-XB",
    "description": "Skin Switch V/H 2G rocker XB",
    "displayName": "2 Switches",
    "image": "3042C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "2 Switches",
    "image": "3042C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "3 Switches",
    "image": "3043C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "3 Switches",
    "image": "3043C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "3 Switches",
    "image": "3043C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-XB",
    "description": "Skin Switch V/H 3G rocker XB",
    "displayName": "3 Switches",
    "image": "3043C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "3 Switches",
    "image": "3043C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "4 Switches",
    "image": "3044C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "4 Switches",
    "image": "3044C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "4 Switches",
    "image": "3044C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-XB",
    "description": "Skin Switch V/H 4G rocker XB",
    "displayName": "4 Switches",
    "image": "3044C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "4 Switches",
    "image": "3044C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "5 Switches",
    "image": "3045C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "5 Switches",
    "image": "3045C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "5 Switches",
    "image": "3045C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-XB",
    "description": "Skin Switch V/H 5G rocker XB",
    "displayName": "5 Switches",
    "image": "3045C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3045C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "5 Switches",
    "image": "3045C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Anthracite",
    "displayName": "6 Switches",
    "image": "3046C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": "40AR-AN",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "6 Switches",
    "image": "3046C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": "40AR-CY",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Vivid White",
    "displayName": "6 Switches",
    "image": "3046C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": "40AR-VW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-XB",
    "description": "Skin Switch V/H 6G rocker XB",
    "displayName": "6 Switches",
    "image": "3046C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": "40AR-XB",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3046C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, Extra White",
    "displayName": "6 Switches",
    "image": "3046C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": "40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3041C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 1 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "1 Switch ",
    "image": "E3041C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3041C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 1 Gang, Arctic White",
    "displayName": "1 Switch ",
    "image": "E3041C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3042C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 2 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "2 Switches",
    "image": "E3042C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3042C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 2 Gang, Arctic White",
    "displayName": "2 Switches",
    "image": "E3042C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3043C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 3 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "3 Switches",
    "image": "E3043C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3043C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 3 Gang, Arctic White",
    "displayName": "3 Switches",
    "image": "E3043C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3044C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 4 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "4 Switches",
    "image": "E3044C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3044C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 4 Gang, Arctic White",
    "displayName": "4 Switches",
    "image": "E3044C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3045C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 5 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "5 Switches",
    "image": "E3045C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3045C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 5 Gang, Arctic White",
    "displayName": "5 Switches",
    "image": "E3045C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3046C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 6 Gang, Vertical/Horizontal, Clip-On, Ash Grey",
    "displayName": "6 Switches",
    "image": "E3046C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": "E40AR-AG",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "E3046C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, 6 Gang, Arctic White",
    "displayName": "6 Switches",
    "image": "E3046C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": "E40AR-AW",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Crowne",
    "displayName": "1 Switch ",
    "image": "S3041C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Silver Shadow",
    "displayName": "1 Switch ",
    "image": "S3041C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 1 Gang, Silver",
    "displayName": "1 Switch ",
    "image": "S3041C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3042C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Crowne",
    "displayName": "2 Switches",
    "image": "S3042C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3042C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Silver Shadow",
    "displayName": "2 Switches",
    "image": "S3042C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3042C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 2 Gang, Silver",
    "displayName": "2 Switches",
    "image": "S3042C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3042VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Crowne",
    "displayName": "3 Switches",
    "image": "S3043C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Silver Shadow",
    "displayName": "3 Switches",
    "image": "S3043C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 3 Gang, Silver",
    "displayName": "3 Switches",
    "image": "S3043C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3043VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3044C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Crowne",
    "displayName": "4 Switches",
    "image": "S3044C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3044C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Silver Shadow",
    "displayName": "4 Switches",
    "image": "S3044C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3044C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 4 Gang, Silver",
    "displayName": "4 Switches",
    "image": "S3044C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3044VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3045C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Crowne",
    "displayName": "5 Switches",
    "image": "S3045C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3045C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Silver Shadow",
    "displayName": "5 Switches",
    "image": "S3045C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3045C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 5 Gang, Silver",
    "displayName": "5 Switches",
    "image": "S3045C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3045VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3046C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Crowne",
    "displayName": "6 Switches",
    "image": "S3046C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": "S40AR-CE",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3046C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Silver Shadow",
    "displayName": "6 Switches",
    "image": "S3046C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": "S40AR-SH",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "S3046C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, 6 Gang, Silver",
    "displayName": "6 Switches",
    "image": "S3046C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3046VA-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": "S40AR-SV",
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3025NW-AN",
    "description": "Clipsal Iconic Night Walk Sensor Light, Motion Activated, Anthracite",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025NW-CY",
    "description": "Clipsal Iconic Night Walk Sensor Light, Motion Activated, Cool Grey",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025NW-VW",
    "description": "Clipsal Iconic Night Walk Sensor Light, Motion Activated, Vivid White",
    "displayName": "Night Walk Sensor",
    "image": "3025NW-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3025G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3043HS-AN",
    "description": "Clipsal Iconic USB Charging Station Skin with Shelf, 3 Gang, Horizontal Mount, Anthracite",
    "displayName": "3 Outlet USB Charging Station with Shelf",
    "image": "3043HS-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3043HS-CY",
    "description": "Clipsal Iconic USB Charging Station Skin with Shelf, 3 Gang, Horizontal Mount, Cool Grey",
    "displayName": "3 Outlet USB Charging Station with Shelf",
    "image": "3043HS-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3043HS-VW",
    "description": "Clipsal Iconic USB Charging Station Skin with Shelf, 3 Gang, Horizontal Mount, Vivid White",
    "displayName": "3 Outlet USB Charging Station with Shelf",
    "image": "3043HS-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3043USBC-AG",
    "description": "Clipsal Iconic Essence USB Charging Station Skin, 3 Gang, Ash Grey",
    "displayName": "3 Outlet USB Charging Station ",
    "image": "E3043USBC-AG.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "E3043USBC-AW",
    "description": "Clipsal Iconic Essence USB Charging Station Skin, 3 Gang, Arctic White",
    "displayName": "3 Outlet USB Charging Station",
    "image": "E3043USBC-AW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043USBC-CE",
    "description": "Clipsal Iconic Styl USB Charging Station Skin, 3 Gang, Crowne",
    "displayName": "3 Outlet USB Charging Station",
    "image": "S3043USBC-CE.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043USBC-SH",
    "description": "Clipsal Iconic Styl USB Charging Station Skin, 3 Gang, Silver Shadow",
    "displayName": "3 Outlet USB Charging Station",
    "image": "S3043USBC-SH.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "S3043USBC-SV",
    "description": "Clipsal Iconic Styl USB Charging Station Skin, 3 Gang, Silver",
    "displayName": "3 Outlet USB Charging Station",
    "image": "S3043USBC-SV.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3043USBG",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025USB2-VW",
    "description": "Clipsal Iconic Double Power Point with Dual USB Charger, Horizontal Mount, 250V, 10A, Vivid White",
    "displayName": "Power Point with Dual USB Charger",
    "image": "3025USB2-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3025USBAC-VW",
    "description": "Clipsal Iconic Switched Socket 1xEx2 USB C charger A+C",
    "displayName": "Power Point with USB A+C Charger",
    "image": "3025USBAC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3041/45C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Vivid White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041D45-VW",
    "description": "Clipsal Iconic Cooking Appliance Isolator Switch and Skin, Horizontal/Vertical Mount, Double Pole, 250V, 45A, Vivid White",
    "displayName": "Cooker Switch 45 Amp Double Pole",
    "image": "3041D45-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041D45-VW",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041/45C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Anthracite",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041/45C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Cooker,Horizontal/Vertical Mount, 250V, 45A,Clip-On, Cool Grey",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041/45C-XW",
    "description": "Clipsal Iconic Switch Plate Skin, 1 Gang, Cooker, Horizontal/Vertical Mount, 250V, 45A,Clip-On, Extra White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Iconic",
    "color": "XW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3041-45C-XB",
    "description": "Skin Switch V/H Cooker DP 45A XB",
    "displayName": "Cooker Switch 45 Amp",
    "image": "3041_45C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "E3041/45C-AG",
    "description": "Clipsal Iconic Essence Switch Plate Skin, 1 Gang, Cooker, Vertical/Horizontal Mount, 45A, Clip-On, Ash Grey",
    "displayName": "Cooker Switch 45 Amp",
    "image": "E3041_45C-AG.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Essence",
    "color": "AG",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "E3041/45C-AW",
    "description": "Clipsal Iconic Essence Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Arctic White",
    "displayName": "Cooker Switch 45 Amp",
    "image": "E3042C-AW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Essence",
    "color": "AW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041/45C-CE",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Crowne",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-CE.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Styl",
    "color": "CE",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041/45C-SH",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Silver Shadow",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-SH.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Styl",
    "color": "SH",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "S3041/45C-SV",
    "description": "Clipsal Iconic Styl Switch Plate Skin, Vertical/Horizontal, COOKER, 45A, Silver",
    "displayName": "Cooker Switch 45 Amp",
    "image": "S3041_45C-SV.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "3041/45-VW",
    "style": "Styl",
    "color": "SV",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "3040C-AN",
    "description": "Clipsal Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Anthracite",
    "displayName": "Blank Plate ",
    "image": "3040C-AN.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3040G",
    "style": "Iconic",
    "color": "AN",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3040C-CY",
    "description": "Clipsal Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Cool Grey",
    "displayName": "Blank Plate ",
    "image": "3040C-CY.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3040G",
    "style": "Iconic",
    "color": "CY",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3040C-VW",
    "description": "Clipsal Iconic Switch Plate Skin, Blank, Horizontal/Vertical Mount, Vivid White",
    "displayName": "Blank Plate ",
    "image": "3040C-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3040G",
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3040C-XB",
    "description": "Skin Switch V/H Blank Plate XB",
    "displayName": "Blank Plate ",
    "image": "3040C-XB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "3040G",
    "style": "Iconic",
    "color": "XB",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3155H4",
    "description": "Quad Socket Mounting Bracket",
    "displayName": "Horizontal Quad Socket Bracket Mount",
    "image": "3155H4.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3000PP/100",
    "description": "Paint Protector",
    "displayName": "Paint Protector",
    "image": "3000PP_100.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3157/4PRM",
    "description": "Quad Socket Plastic Wall Box (54mm depth)",
    "displayName": "Quad Socket Plastic Wall Box (54mm depth)",
    "image": "3157_4PRM.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3004M-VW",
    "description": "Quad Socket Mounting Block (38mm depth)",
    "displayName": "Quad Socket Mounting Block (38mm depth)",
    "image": "3004M-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "449AB-VW",
    "description": "Standard Mounting Block (34mm depth)",
    "displayName": "Standard Mounting Block (34mm depth)",
    "image": "449AB-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3000SM-VW",
    "description": "Shallow Iconic Mounting Block (32mm depth)",
    "displayName": "Shallow Iconic Mounting Block (32mm depth)",
    "image": "3000SM-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3000DM-VW",
    "description": "Deep Iconic Mounting Block (40mm depth)",
    "displayName": "Deep Iconic Mounting Block (40mm depth)",
    "image": "3000DM-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3040CEP-VW",
    "description": "Clipsal Iconic Cable Entry Plate, Horizontal Mount, Vivid White",
    "displayName": "Iconic Cable Entry Plate",
    "image": "3040CEP-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "3041V44-VW",
    "description": "Clipsal Iconic Switch, Vertical, 1 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "1 Switch, IP44",
    "image": "3041V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3042V44-VW",
    "description": "Clipsal Iconic Switch, Vertical, 2 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "2 Switches, IP44",
    "image": "3042V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3043V44-VW",
    "description": "Clipsal Iconic Switch, Vertical, 3 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "3 Switches, IP44",
    "image": "3043V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3044V44-VW",
    "description": "Clipsal Iconic Switch, Vertical, 4 Gang, 1/2 Way, 10AX, 250V, IP44",
    "displayName": "4 Switches, IP44",
    "image": "3044V44-VW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "O3025-XW",
    "description": "Iconic Outdoor Twin Switched Socket IP54",
    "displayName": "Double Power Point",
    "image": "O3025-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3025-BK",
    "description": "Iconic Outdoor Twin Switched Socket IP54",
    "displayName": "Double Power Point",
    "image": "O3025-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3015-XW",
    "description": "Iconic Outdoor Single Switched Socket IP54",
    "displayName": "Single Power Point",
    "image": "O3015-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3015-BK",
    "description": "Iconic Outdoor Single Switched Socket IP54",
    "displayName": "Single Power Point",
    "image": "O3015-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3015T-XW",
    "description": "Iconic Outdoor Single Switched Socket with Timer IP54",
    "displayName": "Single Power Point with Timer",
    "image": "O3015T-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3015T-BK",
    "description": "Iconic Outdoor Single Switched Socket with Timer IP54",
    "displayName": "Single Power Point with Timer",
    "image": "O3015T-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3041HA-XW",
    "description": "Iconic Outdoor Single Switch IP66",
    "displayName": "1 Switch",
    "image": "O3041HA-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3041HA-BK",
    "description": "Iconic Outdoor Single Switch IP66",
    "displayName": "1 Switch",
    "image": "O3041HA-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Switch",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3000CE-25",
    "description": "Iconic Outdoor 25mm Conduit Entry Pck 2",
    "displayName": "25mm Conduit Entry",
    "image": "O3000C_25-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3000CE-25-BK",
    "description": "Iconic Outdoor 25mm Conduit Entry Pck 2",
    "displayName": "25mm Conduit Entry",
    "image": "O3000CE_25-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3000CE-20",
    "description": "Iconic Outdoor 20mm Conduit Entry Pck 2",
    "displayName": "20mm Conduit Entry",
    "image": "O3000CE_20-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "O3000CE-20-BK",
    "description": "Iconic Outdoor 20mm Conduit Entry Pck 2",
    "displayName": "20mm Conduit Entry",
    "image": "O3000C_20-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Outdoor",
    "color": "OutdoorBK",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015-4C-BK",
    "description": "Clipsal Pro Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Quad Power Point",
    "image": "P3015_4C-BK.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "P3015-4XXUAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": true,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015-15C-BK",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Single Power Point 15Amp",
    "image": "P3015_15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015-15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3015V15C-BK"
  },
  {
    "itemNo": "P3015-20C-BK",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, Black",
    "displayName": "Single Power Point 20Amp",
    "image": "P3015_20C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015-20G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015-4XXC-BK",
    "description": "Clipsal Pro Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "P3015-4XXC-BK.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "P3015-4XXUAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015C-BK",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Single Power Point",
    "image": "P3015C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3015VC-BK"
  },
  {
    "itemNo": "P3015V15C-BK",
    "description": "Clipsal Pro Single Power Point Skin, Vertical Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Vertical Single Power Point 15Amp",
    "image": "P3015V15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3015V15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3015-15C-BK"
  },
  {
    "itemNo": "P3015VC-BK",
    "description": "Clipsal Pro Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Vertical Single Power Point ",
    "image": "P3015VC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3015VG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3015C-BK"
  },
  {
    "itemNo": "P3015XC-BK",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Single Power Point with Extra Switch",
    "image": "P3015XC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015XAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025-15C-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, Black",
    "displayName": "Double Power Point 15Amp",
    "image": "P3025-15C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025-15G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025C-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Double Power Point",
    "image": "P3025C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025VC-BK"
  },
  {
    "itemNo": "P3025LC-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, Round Earth, 250V, 10A, Clip-On, Black",
    "displayName": "Double Power Point, Round Earth",
    "image": "P3025LC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025LG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025VC-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Black",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025VG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025C-BK"
  },
  {
    "itemNo": "P3025V-XW",
    "description": "Clipsal Pro Twin Power Point, Vertical Mount, 250V, 10A",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025V-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025V-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025C-XW"
  },
  {
    "itemNo": "P3025VXC-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Vertical Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "P3025VXC-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025VXAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025XC-BK"
  },
  {
    "itemNo": "P3025XC-BK",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, Black",
    "displayName": "Double Power Point with Extra Switch",
    "image": "P3025XC-BK.png",
    "imageScale": 0.98,
    "imageOrientation": "Horizontal",
    "grid": "P3025XAG",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025VXC-BK"
  },
  {
    "itemNo": "P3041C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "1 Switch ",
    "image": "P3041C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3041G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3042C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "2 Switches",
    "image": "P3042C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3042G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3043C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "3 Switches",
    "image": "P3043C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3043G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3044C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "4 Switches",
    "image": "P3044C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3044G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3045C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "5 Switches",
    "image": "P3045C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3045G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3046C-BK",
    "description": "Clipsal Pro Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, Black",
    "displayName": "6 Switches",
    "image": "P3046C-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3046G",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025C-DB",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Dark Blue",
    "displayName": "Double Power Point",
    "image": "P3025C-DB.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025G",
    "style": "Pro",
    "color": "ProDB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025VC-DB"
  },
  {
    "itemNo": "P3025C-GR",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Green",
    "displayName": "Double Power Point",
    "image": "P3025C-GR.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025G",
    "style": "Pro",
    "color": "ProGR",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025C-RD",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, Red",
    "displayName": "Double Power Point",
    "image": "P3025C-RD.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025G",
    "style": "Pro",
    "color": "ProRD",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025VC-RD"
  },
  {
    "itemNo": "P3025VC-DB",
    "description": "Clipsal Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Dark Blue",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-DB.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025VG",
    "style": "Pro",
    "color": "ProDB",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025C-DB"
  },
  {
    "itemNo": "P3025VC-RD",
    "description": "Clipsal Pro Twin Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, Red",
    "displayName": "Vertical Double Power Point ",
    "image": "P3025VC-RD.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025VG",
    "style": "Pro",
    "color": "ProRD",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025C-RD"
  },
  {
    "itemNo": "P3015-4C-XW",
    "description": "Clipsal Pro Quad Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Quad Power Point",
    "image": "P3015_4C-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "P3015-4XXUAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": true,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015C-XW",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Single Power Point",
    "image": "P3015C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3015VC-XW"
  },
  {
    "itemNo": "P3015-15C-XW",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, White",
    "displayName": "Single Power Point 15Amp",
    "image": "P3015_15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015-15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015-20C-XW",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 250V, 20A, Clip-On, White",
    "displayName": "Single Power Point 20Amp",
    "image": "P3015_20C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015-20G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015-4XXC-XW",
    "description": "Clipsal Pro Quad Power Point Skin with 2 extra switches, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Quad Power Point with 2 Extra Switches",
    "image": "P3015-4XXC-XW.png",
    "imageScale": 0.58,
    "imageOrientation": "Horizontal",
    "grid": "P3015-4XXUAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015VC-XW",
    "description": "Clipsal Pro Single Power Point Skin, Vertical Mount, 250V, 10A, Clip-On, White",
    "displayName": "Vertical Single Power Point",
    "image": "P3015VC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3015VG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3015C-XW"
  },
  {
    "itemNo": "P3015V15C-XW",
    "description": "Clipsal Pro Single Power Point Skin, Vertical Mount, 250V, 15A, Clip-On, White",
    "displayName": "Vertical Single Power Point 15Amp",
    "image": "P3015V15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3015V15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015XC-XW",
    "description": "Clipsal Pro Single Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Single Power Point with Extra Switch",
    "image": "P3015XC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015XAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025C-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 10A, Clip-On, White",
    "displayName": "Double Power Point",
    "image": "P3025C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025V-XW"
  },
  {
    "itemNo": "P3025-15C-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 250V, 15A, Clip-On, White",
    "displayName": "Double Power Point 15Amp",
    "image": "P3025-15C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025-15G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025LC-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, Round Earth, 250V, 10A, Clip-On, White",
    "displayName": "Double Power Point, Round Earth",
    "image": "P3025LC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025LG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025PIDC-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, Power Indicator, 250V, 10A, White",
    "displayName": "Double Power Point, Power Indicator",
    "image": "P3025PIDC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025PIDG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015D-XW",
    "description": "Clipsal Pro Single Power Point, Double Pole, Horizontal Mount, 250V, 10A",
    "displayName": "Double Pole Single Power Point",
    "image": "P3015D-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015D-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3015D15-XW",
    "description": "Clipsal Pro Single Power Point, Double Pole, Horizontal Mount, 250V, 15A",
    "displayName": "Double Pole Single Power Point",
    "image": "P3015D15-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3015D15-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025D-XW",
    "description": "Clipsal Pro Twin Power Point, Double Pole, Horizontal Mount, 250V, 10A",
    "displayName": "Double Pole Double Power Point",
    "image": "P3025D-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025D-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025VXC-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Vertical Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Vertical Double Power Point with Extra Switch  ",
    "image": "P3025VXC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3025VXAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": "P3025XC-XW"
  },
  {
    "itemNo": "P3025XC-XW",
    "description": "Clipsal Pro Twin Power Point Skin, Horizontal Mount, 1ExBlank, 10A, 250V, Clip-On, White",
    "displayName": "Double Power Point with Extra Switch",
    "image": "P3025XC-XW.png",
    "imageScale": 0.98,
    "imageOrientation": "Horizontal",
    "grid": "P3025XAG",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": "P3025VXC-XW"
  },
  {
    "itemNo": "P3025USB2-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+A, 10A, 250V",
    "displayName": "Power Point with Dual USB Charger",
    "image": "P3025USB2-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025USB2-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3025USBAC-XW",
    "description": "Clipsal Pro Twin Power Point, Horizontal Mount, 1Ex2USBCHRG, Type A+C, 10A, 250V",
    "displayName": "Power Point with USB A+C Charger",
    "image": "P3025USBAC-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": "P3025USBAC-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Socket",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 1 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "1 Switch ",
    "image": "P3041C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3041VA-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3042C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 2 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "2 Switches",
    "image": "P3042C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3042VA-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3043C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 3 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "3 Switches",
    "image": "P3043C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3043VA-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3044C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 4 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "4 Switches",
    "image": "P3044C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3044VA-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3045C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 5 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "5 Switches",
    "image": "P3045C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3045G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3046C-XW",
    "description": "Clipsal Pro Switch Plate Skin, 6 Gang, Horizontal/Vertical Mount, Clip-On, White",
    "displayName": "6 Switches",
    "image": "P3046C-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3046G",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P223H-3A",
    "description": "Clipsal Protective box IK10 with lockable lid",
    "displayName": "Protective Box IK10 Lockable Lid",
    "image": "P223H-3A.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3000PP-50",
    "description": "Clipsal Pro Protective Paint Cover - 50 pack",
    "displayName": "Paint Protector",
    "image": "P3000PP-50.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3000T",
    "description": "Clipsal Pro Tool for Skin Removal",
    "displayName": "Skin Removal Tool",
    "image": "P3000T.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041-45-XW",
    "description": "Clipsal Pro Cooking Appliance Isolator Switch, Horizontal/Vertical Mount, Single Pole, 250V, 45A",
    "displayName": "Single Pole Cooking Appliance Isolator Switch",
    "image": "P3041-45-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041D45-XW",
    "description": "Clipsal Pro Cooking Appliance Isolator Switch, Horizontal/Vertical Mount, Double Pole, 250V, 45A",
    "displayName": "Double Pole Cooking Appliance Isolator Switch",
    "image": "P3041D45-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041V44-XW",
    "description": "Clipsal Pro Switch, Vertical, 1 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "1 Switch, IP44",
    "image": "P3041V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3042V44-XW",
    "description": "Clipsal Pro Switch, Vertical, 2 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "2 Switches, IP44",
    "image": "P3042V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3043V44-XW",
    "description": "Clipsal Pro Switch, Vertical, 3 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "3 Switches, IP44",
    "image": "P3043V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3044V44-XW",
    "description": "Clipsal Pro Switch, Vertical, 4 Gang, 1/2 Way, 20A/16AX, 250V, IP44",
    "displayName": "4 Switches, IP44",
    "image": "P3044V44-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3043HUSB-XW",
    "description": "Clipsal Pro USB Charging Station, 3 Outlet, Type A",
    "displayName": "3 Outlet USB Charging Station ",
    "image": "P3043HUSB-XW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "P3040VX-BK",
    "description": "Clipsal Pro Blank Switch Plate, Horizontal/Vertical Mount",
    "displayName": "Blank Plate ",
    "image": "P3040VX-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3040VX-XW",
    "description": "Clipsal Pro Blank Switch Plate, Horizontal/Vertical Mount",
    "displayName": "Blank Plate ",
    "image": "P3040VX-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3019-XW",
    "description": "Clipsal Pro Pneumatic Switch, Vertical Mount, Time Delay 10A, 250V",
    "displayName": "Pneumatic Switch",
    "image": "P3019-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": null,
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Vertical",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041A-XW",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 1 Switch",
    "image": "P3041A-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3041A-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3042A-XW",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 2 Switch",
    "image": "P3042A-XW.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3042A-XW",
    "style": "Pro",
    "color": "ProXW",
    "includedRockerItemNo": "P40AR-XW",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3041A-BK",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 1 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 1 Switch",
    "image": "P3041A-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3041A-BK",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "P3042A-BK",
    "description": "Clipsal Pro Architrave Switch, Vertical Mount, 2 Gang, 250V, 20A/16AX",
    "displayName": "Architrave 2 Switch",
    "image": "P3042A-BK.png",
    "imageScale": 1,
    "imageOrientation": "Vertical",
    "grid": "P3042A-BK",
    "style": "Pro",
    "color": "ProBK",
    "includedRockerItemNo": "P40AR-BK",
    "type": "Switch",
    "disableSlots": false,
    "pro": true,
    "orientationSupport": "Both",
    "otherOrientation": null
  },
  {
    "itemNo": "3025USBC-VW",
    "description": "Clipsal Iconic Double Power Point Horizontal Mount, Twin socket, 10A, 240V, USB Fast charger, Type C, 25W",
    "displayName": "Double Power Point with USB Type C",
    "image": "3025USBC-VW.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": "Iconic",
    "color": "VW",
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null
  },
  {
    "itemNo": "CLP501902",
    "description": "Wiser Zigbee to IP Network Hub 100-240 V AC, IP20",
    "displayName": "Wiser Hub",
    "displaySubtitle": "Zigbee to IP Network",
    "image": "CLP501902.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Hubs"
  },
  {
    "itemNo": "CLP501902_0001",
    "description": "Wiser Docking Kit, Table Stand",
    "displayName": "Wiser Hub Table Stand",
    "displaySubtitle": "Docking Kit",
    "image": "CLP501902_0001.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Hubs"
  },
  {
    "itemNo": "CLP724419",
    "description": "Wiser, IP Camera, Wi-Fi, Outdoor, IP56",
    "displayName": "Wiser IP Camera",
    "displaySubtitle": "Wi-Fi, Outdoor, IP56",
    "image": "CLP724419.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Cameras"
  },
  {
    "itemNo": "CLP723419",
    "description": "Wiser, IP Camera, Wi-Fi, Pan and Tilt Adjustment, Indoor, IP20",
    "displayName": "Wiser IP Camera",
    "displaySubtitle": "Wi-Fi, Pan and Tilt Adjustment, Indoor, IP20",
    "image": "CLP723419.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Cameras"
  },
  {
    "itemNo": "CLP599WSA",
    "description": "Wiser 240V Smoke Alarm Square",
    "displayName": "Wiser Smoke Alarm",
    "displaySubtitle": "240V Square",
    "image": "CLP599WSA.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Smoke Alarms"
  },
  {
    "itemNo": "CLP599WSAL",
    "description": "Wiser Lithium Battery Smoke alarm",
    "displayName": "Wiser Smoke Alarm",
    "displaySubtitle": "Lithium Battery",
    "image": "CLP599WSA.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Smoke Alarms"
  },
  {
    "itemNo": "755WSA",
    "description": "240v Smoke Alarm, works with Wiser round",
    "displayName": "Smoke Alarm",
    "displaySubtitle": "240V, works with Wiser round",
    "image": "755WSA.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Smoke Alarms"
  },
  {
    "itemNo": "CLP595011",
    "description": "Wiser Motion Sensor3 V DC, IP20",
    "displayName": "Wiser Motion Sensor",
    "displaySubtitle": "3V DC, IP20",
    "image": "CLP595011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "CLP593011",
    "description": "Wiser Temperature/Humidity Sensor 3 V DC, IP20",
    "displayName": "Wiser Temperature/Humidity Sensor",
    "displaySubtitle": "White",
    "image": "CLP593011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "CLP592011",
    "description": "Wiser Water Leakage Sensor 3 V DC, IP20",
    "displayName": "Wiser Water Leakage Sensor",
    "displaySubtitle": "White",
    "image": "CLP592011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "CLP591011",
    "description": "Wiser Window/Door  Sensor 3 V DC, IP44",
    "displayName": "Wiser Window/Door Sensor",
    "displaySubtitle": "White",
    "image": "CLP591011.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Sensors"
  },
  {
    "itemNo": "CLP501401",
    "description": "Wiser IR Converter 100-240 V AC, 50/60 Hz, IP20",
    "displayName": "Wiser IR Converter",
    "displaySubtitle": "100-240 V AC, 50/60 Hz, IP20",
    "image": "CLP501401.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "IR Converter"
  },
  {
    "itemNo": "CLP5010WDZ",
    "description": "Wiser Micro Module Dimmer 200 W Max, 240 V",
    "displayName": "Wiser Micro Module Dimmer",
    "displaySubtitle": "200 W Max, 240 V, Grey",
    "image": "CLP5010WDZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  },
  {
    "itemNo": "CLP5011WSZ",
    "description": "Wiser Micro Module Switch 10 AX, 240 V",
    "displayName": "Wiser Micro Module Switch",
    "displaySubtitle": "10 AX, 240 V, Grey",
    "image": "CLP5011WSZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  },
  {
    "itemNo": "CLP5015WBZ",
    "description": "Wiser Micro Module Blind Controller 4 A, 220-240 V AC, 50Hz",
    "displayName": "Wiser Micro Module Blind Controller",
    "displaySubtitle": "Grey",
    "image": "CLP5015WBZ.png",
    "imageScale": 1,
    "imageOrientation": "Horizontal",
    "grid": null,
    "style": null,
    "color": null,
    "includedRockerItemNo": null,
    "type": "Other",
    "disableSlots": false,
    "pro": false,
    "orientationSupport": "Horizontal",
    "otherOrientation": null,
    "menuCategories": [
      "Wiser"
    ],
    "displaySubcategory": "Micro Modules"
  }
]

const InterfaceProducts: readonly InterfaceProduct[] = 
[
  {
    "itemNo": "E40AR-AW",
    "description": "Clipsal Iconic Essence Rocker, Blank, Arctic White",
    "name": "Standard",
    "image": "E40AR-AW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40ML",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40AR-AG",
    "description": "Clipsal Iconic Essence Rocker, Blank, Ash Grey",
    "name": "Standard",
    "image": "E40AR-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AR-AN",
    "description": "Clipsal Iconic Blank Rocker, Anthracite, 10 Pack",
    "name": "Standard",
    "image": "40AR-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AR-CY",
    "description": "Clipsal Iconic Blank Rocker, Cool Grey, 10 Pack",
    "name": "Standard",
    "image": "40AR-CY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AR-VW",
    "description": "Clipsal Iconic Blank Rocker, Vivid White, 10 Pack",
    "name": "Standard",
    "image": "40AR-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AR-XW",
    "description": "Dolly Rocker BLANK Pck 10",
    "name": "Standard",
    "image": "40AR-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XW",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40AR-XB",
    "description": "Dolly Rocker BLANK Pck 10",
    "name": "Standard",
    "image": "40AR-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "S40AR-CE",
    "description": "Clipsal Iconic Styl Rocker, Blank, Crowne",
    "name": "Standard",
    "image": "S40AR-CE.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40AR-SV",
    "description": "Clipsal Iconic Styl Rocker, Blank, Silver",
    "name": "Standard",
    "image": "S40AR-SV.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40AR-SH",
    "description": "Clipsal Iconic Styl Rocker, Blank, Silver Shadow",
    "name": "Standard",
    "image": "S40AR-SH.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40AR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": [
      "40M",
      "40MIL"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40R32-AW",
    "description": "Clipsal Iconic Essence Rocker, 32A, Arctic White",
    "name": "32Amp Standard",
    "image": "E40R32-AW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40R32-AG",
    "description": "Clipsal Iconic Essence Rocker, 32A, Ash Grey",
    "name": "32Amp Standard",
    "image": "E40R32-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40R32-AN",
    "description": "Clipsal Iconic 32A Rocker, Anthracite, 10 Pack",
    "name": "32Amp Standard",
    "image": "40R32-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40R32-XB",
    "description": "Dolly Rocker 32A BLANK Pck 10",
    "name": "32Amp Standard",
    "image": "40R32-XB.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40R33",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32-CE",
    "description": "Clipsal Iconic Styl Rocker, 32A, Crowne",
    "name": "32Amp Standard",
    "image": "S40R32-CE.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32-SV",
    "description": "Clipsal Iconic Styl Rocker, 32A, Silver",
    "name": "32Amp Standard",
    "image": "S40R32-SV.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32-SH",
    "description": "Clipsal Iconic Styl Rocker, 32A, Silver Shadow",
    "name": "32Amp Standard",
    "image": "S40R32-SH.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40MD20COOK-VW",
    "description": "Clipsal Iconic Switch Mechanism, Cooker, 1-Way, Double Pole, 250V, 20AX, Vivid White",
    "name": "20AX Cooker",
    "image": "40MD20COOK-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40M32COOK-VW",
    "description": "Clipsal Iconic Switch Mechanism, Cooker, 1-Way, 250V, 32A, Vivid White",
    "name": "32A Cooker",
    "image": "40M32COOK-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40R32C-AG",
    "description": "Clipsal Iconic Essence Rocker, 32A, COOKER, Ash Grey",
    "name": "32Amp Cooker",
    "image": "E40R32C-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40R32C",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40R32C-AW",
    "description": "Clipsal Iconic Essence Rocker, 32A, COOKER, Arctic White",
    "name": "32Amp Cooker",
    "image": "E40R32C-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40R32C",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32C-CE",
    "description": "Clipsal Iconic Styl Rocker, 32A, COOKER, Crowne",
    "name": "32Amp Cooker",
    "image": "S40R32C-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40R32C",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32C-SH",
    "description": "Clipsal Iconic Styl Rocker, 32A, COOKER, Silver Shadow",
    "name": "32Amp Cooker",
    "image": "S40R32C-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40R32C",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40R32C-SV",
    "description": "Clipsal Iconic Styl Rocker, 32A, COOKER, Silver",
    "name": "32Amp Cooker",
    "image": "S40R32C-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40R32C",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40ACR-VW",
    "description": "Clipsal Iconic Air Conditioner Rocker, Vivid White, 10 Pack",
    "name": "Airconditioning",
    "image": "40ACR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40ACR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40ALR-VW",
    "description": "Clipsal Iconic Alarm Rocker, Vivid White, 10 Pack",
    "name": "Alarm",
    "image": "40ALR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40ALR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40AMR-VW",
    "description": "Clipsal Iconic Auto/Manual Rocker, Vivid White, 10 Pack",
    "name": "Auto manual",
    "image": "40AMR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40AMR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BDR-VW",
    "description": "Clipsal Iconic Bed Rocker, Vivid White, 10 Pack",
    "name": "Bed",
    "image": "40BDR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BDR-AG",
    "description": "Clipsal Iconic Essence Rocker, BED, Ash Grey",
    "name": "Bed",
    "image": "E40BDR-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BDR-AW",
    "description": "Clipsal Iconic Essence Rocker, BED, Arctic White",
    "name": "Bed",
    "image": "E40BDR-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BDR-CE",
    "description": "Clipsal Iconic Styl Rocker, BED, Crowne",
    "name": "Bed",
    "image": "S40BDR-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BDR-SH",
    "description": "Clipsal Iconic Styl Rocker, BEDSilver Shadow",
    "name": "Bed",
    "image": "S40BDR-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BDR-SV",
    "description": "Clipsal Iconic Styl Rocker, BED, Silver",
    "name": "Bed",
    "image": "S40BDR-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40BDR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BD1R-VW",
    "description": "Clipsal Iconic Bed 1 Rocker, Vivid White, 10 Pack",
    "name": "Bed 1",
    "image": "40BD1R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD1R-AG",
    "description": "Clipsal Iconic Essence Rocker, BED1, Ash Grey",
    "name": "Bed 1",
    "image": "E40BD1R-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD1R-AW",
    "description": "Clipsal Iconic Essence Rocker, BED1, Arctic White",
    "name": "Bed 1",
    "image": "E40BD1R-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD1R-CE",
    "description": "Clipsal Iconic Styl Rocker, BED 1, Crowne",
    "name": "Bed 1",
    "image": "S40BD1R-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD1R-SH",
    "description": "Clipsal Iconic Styl Rocker, BED 1, Silver Shadow",
    "name": "Bed 1",
    "image": "S40BD1R-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD1R-SV",
    "description": "Clipsal Iconic Styl Rocker, BED 1, Silver",
    "name": "Bed 1",
    "image": "S40BD1R-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40BD1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BD2R-VW",
    "description": "Clipsal Iconic Bed 2 Rocker, Vivid White, 10 Pack",
    "name": "Bed 2",
    "image": "40BD2R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD2R-AG",
    "description": "Clipsal Iconic Essence Rocker, BED2, Ash Grey",
    "name": "Bed 2",
    "image": "E40BD2R-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD2R-AW",
    "description": "Clipsal Iconic Essence Rocker, BED2, Arctic White",
    "name": "Bed 2",
    "image": "E40BD2R-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD2R-CE",
    "description": "Clipsal Iconic Styl Rocker, BED 2, Crowne",
    "name": "Bed 2",
    "image": "S40BD2R-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD2R-SH",
    "description": "Clipsal Iconic Styl Rocker, BED 2, Silver Shadow",
    "name": "Bed 2",
    "image": "S40BD2R-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD2R-SV",
    "description": "Clipsal Iconic Styl Rocker, BED 2, Silver",
    "name": "Bed 2",
    "image": "S40BD2R-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40BD2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BD3R-VW",
    "description": "Clipsal Iconic Bed 3 Rocker, Vivid White, 10 Pack",
    "name": "Bed 3",
    "image": "40BD3R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD3R-AG",
    "description": "Clipsal Iconic Essence Rocker, BED3, Ash Grey",
    "name": "Bed 3",
    "image": "E40BD3R-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD3R-AW",
    "description": "Clipsal Iconic Essence Rocker, BED3, Arctic White",
    "name": "Bed 3",
    "image": "E40BD3R-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD3R-CE",
    "description": "Clipsal Iconic Styl Rocker, BED 3, Crowne",
    "name": "Bed 3",
    "image": "S40BD3R-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD3R-SH",
    "description": "Clipsal Iconic Styl Rocker, BED 3, Silver Shadow",
    "name": "Bed 3",
    "image": "S40BD3R-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD3R-SV",
    "description": "Clipsal Iconic Styl Rocker, BED 3, Silver",
    "name": "Bed 3",
    "image": "S40BD3R-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40BD3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BD4R-VW",
    "description": "Clipsal Iconic Bed 4 Rocker, Vivid White, 10 Pack",
    "name": "Bed 4",
    "image": "40BD4R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD4R-AG",
    "description": "Clipsal Iconic Essence Rocker, BED4, Ash Grey",
    "name": "Bed 4",
    "image": "E40BD4R-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40BD4R-AW",
    "description": "Clipsal Iconic Essence Rocker, BED4, Arctic White",
    "name": "Bed 4",
    "image": "E40BD4R-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD4R-CE",
    "description": "Clipsal Iconic Styl Rocker, BED 4, Crowne",
    "name": "Bed 4",
    "image": "S40BD4R-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD4R-SH",
    "description": "Clipsal Iconic Styl Rocker, BED 4, Silver Shadow",
    "name": "Bed 4",
    "image": "S40BD4R-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40BD4R-SV",
    "description": "Clipsal Iconic Styl Rocker, BED 4, Silver",
    "name": "Bed 4",
    "image": "S40BD4R-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40BD4R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40CR-AG",
    "description": "Clipsal Iconic Essence Rocker, COOKER, Ash Grey",
    "name": "Cooker",
    "image": "E40CR-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40CR",
    "mechs": [
      "40MD20"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40CR-AW",
    "description": "Clipsal Iconic Essence Rocker, COOKER, Arctic White",
    "name": "Cooker",
    "image": "E40CR-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40CR",
    "mechs": [
      "40MD20"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40CR-CE",
    "description": "Clipsal Iconic Styl Rocker, COOKER, Crowne",
    "name": "Cooker",
    "image": "S40CR-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40CR",
    "mechs": [
      "40MD20"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40CR-SH",
    "description": "Clipsal Iconic Styl Rocker, COOKER, Silver Shadow",
    "name": "Cooker",
    "image": "S40CR-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40CR",
    "mechs": [
      "40MD20"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40CR-SV",
    "description": "Clipsal Iconic Styl Rocker, COOKER, Silver",
    "name": "Cooker",
    "image": "S40CR-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40CR",
    "mechs": [
      "40MD20"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40DR-VW",
    "description": "Clipsal Iconic Dining Room Rocker, Vivid White, 10 Pack",
    "name": "Dining",
    "image": "40DR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RD-AG",
    "description": "Clipsal Iconic Essence Rocker, DINING, Ash Grey",
    "name": "Dining",
    "image": "E40RD-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RD-AW",
    "description": "Clipsal Iconic Essence Rocker, DINING, Arctic White",
    "name": "Dining",
    "image": "E40RD-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RD-CE",
    "description": "Clipsal Iconic Styl Rocker, DINING, Crowne",
    "name": "Dining",
    "image": "S40RD-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RD-SH",
    "description": "Clipsal Iconic Styl Rocker, DINING, Silver Shadow",
    "name": "Dining",
    "image": "S40RD-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RD-SV",
    "description": "Clipsal Iconic Styl Rocker, DINING, Silver",
    "name": "Dining",
    "image": "S40RD-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RD",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40FAR-VW",
    "description": "Clipsal Iconic Family Room Rocker, Vivid White, 10 Pack",
    "name": "Family",
    "image": "40FAR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40FAR-AG",
    "description": "Clipsal Iconic Essence Rocker, FAMILY, Ash Grey",
    "name": "Family",
    "image": "E40FAR-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40FAR-AW",
    "description": "Clipsal Iconic Essence Rocker, FAMILY, Arctic White",
    "name": "Family",
    "image": "E40FAR-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40FAR-CE",
    "description": "Clipsal Iconic Styl Rocker, FAMILY, Crowne",
    "name": "Family",
    "image": "S40FAR-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40FAR-SH",
    "description": "Clipsal Iconic Styl Rocker, FAMILY, Silver Shadow",
    "name": "Family",
    "image": "S40FAR-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40FAR-SV",
    "description": "Clipsal Iconic Styl Rocker, FAMILY, Silver",
    "name": "Family",
    "image": "S40FAR-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40FAR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40FR-VW",
    "description": "Clipsal Iconic Fan Rocker, Vivid White, 10 Pack",
    "name": "Fan",
    "image": "40FR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RF-AG",
    "description": "Clipsal Iconic Essence Rocker, FAN, Ash Grey",
    "name": "Fan",
    "image": "E40RF-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RF-AW",
    "description": "Clipsal Iconic Essence Rocker, FAN, Arctic White",
    "name": "Fan",
    "image": "E40RF-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RF-CE",
    "description": "Clipsal Iconic Styl Rocker, FAN, Crowne",
    "name": "Fan",
    "image": "S40RF-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RF-SH",
    "description": "Clipsal Iconic Styl Rocker, FAN, Silver Shadow",
    "name": "Fan",
    "image": "S40RF-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RF-SV",
    "description": "Clipsal Iconic Styl Rocker, FAN, Silver",
    "name": "Fan",
    "image": "S40RF-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RF",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40FRR-VW",
    "description": "Clipsal Iconic Fridge Rocker, Vivid White, 10 Pack",
    "name": "Fridge",
    "image": "40FRR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40FRR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40HR-VW",
    "description": "Clipsal Iconic Heat Rocker, Vivid White, 10 Pack",
    "name": "Heat",
    "image": "40HR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RH-AG",
    "description": "Clipsal Iconic Essence Rocker, HEAT, Ash Grey",
    "name": "Heat",
    "image": "E40RH-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RH-AW",
    "description": "Clipsal Iconic Essence Rocker, HEAT, Arctic White",
    "name": "Heat",
    "image": "E40RH-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RH-CE",
    "description": "Clipsal Iconic Styl Rocker, HEAT, Crowne",
    "name": "Heat",
    "image": "S40RH-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RH-SH",
    "description": "Clipsal Iconic Styl Rocker, HEAT, Silver Shadow",
    "name": "Heat",
    "image": "S40RH-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RH-SV",
    "description": "Clipsal Iconic Styl Rocker, HEAT, Silver",
    "name": "Heat",
    "image": "S40RH-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RH",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40KR-VW",
    "description": "Clipsal Iconic Kitchen Rocker, Vivid White, 10 Pack",
    "name": "Kitchen",
    "image": "40KR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RK-AG",
    "description": "Clipsal Iconic Essence Rocker, KITCHEN, Ash Grey",
    "name": "Kitchen",
    "image": "E40RK-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RK-AW",
    "description": "Clipsal Iconic Essence Rocker, KITCHEN, Arctic White",
    "name": "Kitchen",
    "image": "E40RK-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RK-CE",
    "description": "Clipsal Iconic Styl Rocker, KITCHEN, Crowne",
    "name": "Kitchen",
    "image": "S40RK-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RK-SH",
    "description": "Clipsal Iconic Styl Rocker, KITCHEN, Silver Shadow",
    "name": "Kitchen",
    "image": "S40RK-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RK-SV",
    "description": "Clipsal Iconic Styl Rocker, KITCHEN, Silver",
    "name": "Kitchen",
    "image": "S40RK-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RK",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40LR-VW",
    "description": "Clipsal Iconic Light Rocker, Vivid White, 10 Pack",
    "name": "Light",
    "image": "40LR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RL-AG",
    "description": "Clipsal Iconic Essence Rocker, LIGHT, Ash Grey",
    "name": "Light",
    "image": "E40RL-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RL-AW",
    "description": "Clipsal Iconic Essence Rocker, LIGHT, Arctic White",
    "name": "Light",
    "image": "E40RL-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RL-CE",
    "description": "Clipsal Iconic Styl Rocker, LIGHT, Crowne",
    "name": "Light",
    "image": "S40RL-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RL-SH",
    "description": "Clipsal Iconic Styl Rocker, LIGHT, Silver Shadow",
    "name": "Light",
    "image": "S40RL-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RL-SV",
    "description": "Clipsal Iconic Styl Rocker, LIGHT, Silver",
    "name": "Light",
    "image": "S40RL-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RL",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40LOR-VW",
    "description": "Clipsal Iconic Lounge Rocker, Vivid White, 10 Pack",
    "name": "Lounge",
    "image": "40LOR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RLO-AG",
    "description": "Clipsal Iconic Essence Rocker, LOUNGE, Ash Grey",
    "name": "Lounge",
    "image": "E40RLO-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40RLO-AW",
    "description": "Clipsal Iconic Essence Rocker, LOUNGE, Arctic White",
    "name": "Lounge",
    "image": "E40RLO-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RLO-CE",
    "description": "Clipsal Iconic Styl Rocker, LOUNGE, Crowne",
    "name": "Lounge",
    "image": "S40RLO-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RLO-SH",
    "description": "Clipsal Iconic Styl Rocker, LOUNGE, Silver Shadow",
    "name": "Lounge",
    "image": "S40RLO-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RLO-SV",
    "description": "Clipsal Iconic Styl Rocker, LOUNGE, Silver",
    "name": "Lounge",
    "image": "S40RLO-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RLO",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA5C-TN",
    "description": "Clipsal Iconic, Data Socket, Category 5E, U/UTP, RJ45 , Unshielded, Translucent",
    "name": "Cat 5E Connector RJ45 Unshielded",
    "image": "40RJ45SMA5C-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6SHC-TN",
    "description": "Clipsal Iconic, Data Socket, Category 6, U/UTP, RJ45, Shuttered, Unshielded, Translucent",
    "name": "Cat 6 Connector RJ45 Shuttered, Unshielded",
    "image": "40RJ45SMA6SH-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-TN",
    "description": "Clipsal Iconic, Data Socket, Category 6, U/UTP, RJ45 ,Unshielded, Translucent",
    "name": "Cat 6 Connector RJ45 Unshielded",
    "image": "40RJ45SMA6C-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6ASC-TN",
    "description": "Cat 6A Connector RJ45 Shuttered, Unshielded, Translucent",
    "name": "Cat 6A Connector RJ45 Shuttered, Unshielded",
    "image": "40RJ45SMA6ASC-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6AC-TN",
    "description": "Clipsal Iconic, Data Socket, Category 6, U/UTP, RJ45 Unshielded, Translucent",
    "name": "Cat 6A Connector RJ45, Unshielded",
    "image": "40RJ45SMA6C-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BC/2-TN",
    "description": "Clipsal Iconic Banana Audio Connector, Red Band, Translucent",
    "name": "Connector Banana Audio RD+BK",
    "image": "40BC2-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "40BC/2-TN (RD)",
      "40BC/2-TN (BK)"
    ],
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BC/2-TN (RD)",
    "description": "Clipsal Iconic Banana Audio Connector, Red Band, Translucent (RD)",
    "name": "Connector Banana Audio RD",
    "image": "40BC2_TN-RD.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40BC/2-TN (BK)",
    "description": "Clipsal Iconic Banana Audio Connector, Red Band, Translucent (BK)",
    "name": "Connector Banana Audio BK",
    "image": "40BC2_TN-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ64SMT-TN",
    "description": "Clipsal Iconic Data Socket, Category 3, 4 Contact, Telephone, Translucent",
    "name": "Connector RJ12 4 pin Telephone Symbol",
    "image": "40RJ64SMT-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA5SHC-TN",
    "description": "RJ45 Jack CAT5E UTP 40M Shutter",
    "name": "Connector RJ45 Cat5e Shuttered  Unshielded",
    "image": "40RJ45SMA5SH-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-BU",
    "description": "RJ45 Jack CAT6 UTP 40M",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6-BU.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-GR",
    "description": "RJ45 Jack CAT6 UTP 40M",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6-GR.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-RD",
    "description": "RJ45 Jack CAT6 UTP 40M",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6-RD.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-YL",
    "description": "RJ45 Jack CAT6 UTP 40M",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6-YL.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-BK",
    "description": "Cat 6 Connector RJ45 Unshielded.",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6C-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6C-XW",
    "description": "Cat 6 Connector RJ45 Unshielded.",
    "name": "Connector RJ45 Cat6 Unshielded",
    "image": "40RJ45SMA6C-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": "Iconic",
    "color": "XW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40EDIMKB-CE",
    "description": "Clipsal Iconic Styl Dimmer Knob Kit, Crowne",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-CE.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40EDIMKB-SV",
    "description": "Clipsal Iconic Styl Dimmer Knob Kit, Silver",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-SV.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40EDIMKB-SH",
    "description": "Clipsal Iconic Styl Dimmer Knob Kit, Silver Shadow",
    "name": "Rotary Dimmer",
    "image": "S40EDIMKB-SH.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "S40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBCAP-AG",
    "description": "Clipsal Iconic Mechanism Cap, Dual USB Charger, 5 Pack",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E2USBCAP",
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBCAP-AN",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger, Anthracite, 5 Pack",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E2USBCAP",
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBCAP-CY",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger, Cool Grey, 5 Pack",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E2USBCAP",
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBCAP-VW",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger, Vivid White, 5 Pack",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E2USBCAP",
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBCAP-WY",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger, Warm Grey, 5 Pack",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E2USBCAP",
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBACCAP-AG",
    "description": "Clipsal Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBACCAP-AN",
    "description": "Clipsal Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBACCAP-CY",
    "description": "Clipsal Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBACCAP-VW",
    "description": "Clipsal Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E2USBACCAP-WY",
    "description": "Clipsal Iconic - Mechanism Cap Dual USB Type A+C",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E2USBACCAP",
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40EDIMKB-AN",
    "description": "Clipsal Iconic Rotary Dimmer Knob Parts Pack, Anthracite",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-AN.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40EDIMKB-AG",
    "description": "Clipsal Iconic Rotary Dimmer Knob, Parts Pack",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-AG.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40EDIMKB-CY",
    "description": "Clipsal Iconic Rotary Dimmer Knob Parts Pack, Cool Grey",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-CY.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40EDIMKB-VW",
    "description": "Clipsal Iconic Rotary Dimmer Knob Parts Pack, Vivid White",
    "name": "Rotary Dimmer",
    "image": "40EDIMKB-VW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "41EPIRM-TN",
    "description": "Clipsal Iconic PIR Motion Sensor Mechanism, 750W, 3-Wire",
    "name": "PIR Sensor",
    "image": "41EPIRM-TN.png",
    "category": "Accessories",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40APB-AG",
    "description": "Clipsal Iconic Essence Pushbutton Assembly, Blank, Ash Grey",
    "name": "Pushbutton Dimmer",
    "image": "E40APB-AG.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APB-AN",
    "description": "Clipsal Iconic Pushbutton Assembly, Blank, Anthracite, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-AN.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APB-CY",
    "description": "Clipsal Iconic Pushbutton Assembly, Blank, Cool Grey, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-CY.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APB-VW",
    "description": "Clipsal Iconic Pushbutton Assembly, Blank, Vivid White, 5 Pack",
    "name": "Pushbutton Dimmer",
    "image": "40APB-VW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APB-XB",
    "description": "Mech cap Push Button BLANK XB Pck 5",
    "name": "Pushbutton Dimmer",
    "image": "40AR-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APB-CE",
    "description": "Clipsal Iconic Styl Pushbutton Assembly, Blank, Crowne,",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-CE.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APB-SV",
    "description": "Clipsal Iconic Styl Pushbutton Assembly, Blank, Silver",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-SV.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APB-SH",
    "description": "Clipsal Iconic Styl Pushbutton Assembly, Blank, Silver Shadow",
    "name": "Pushbutton Dimmer",
    "image": "S40AR-SH.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "displayedMechs": [
      "41E300PBUD2SM-VW",
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41E2PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS",
      "41E10PBSWMZ-VW",
      "41E2PBSWMZ-VW",
      "41EPBDWCLMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APBF-VW",
    "description": "Iconic Push Button Assembly, Fan, Vivid White",
    "name": "Pushbutton Fan Controller",
    "image": "40APBF-VW.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APBF-CY",
    "description": "Iconic Push Button Assembly, Fan, Cool Grey",
    "name": "Pushbutton Fan Controller",
    "image": "40APBF-CY.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APBF-AN",
    "description": "Iconic Push Button Assembly, Fan, Anthracite",
    "name": "Pushbutton Fan Controller",
    "image": "40APBF-AN.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40APBF-XB",
    "description": "Iconic Push Button Assembly, Fan, Xtra Black",
    "name": "Pushbutton Fan Controller",
    "image": "40APBF-XB.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APBF-SV",
    "description": "Iconic Styl Push Button Assembly, Fan, Silver",
    "name": "Pushbutton Fan Controller",
    "image": "S40APBF-SV.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APBF-SH",
    "description": "Iconic Styl Push Button Assembly, Fan, Silver Shadow",
    "name": "Pushbutton Fan Controller",
    "image": "S40APBF-SH.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40APBF-CE",
    "description": "Iconic Styl Push Button Assembly, Fan, Crowne",
    "name": "Pushbutton Fan Controller",
    "image": "S40APBF-CE.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40APBF-AW",
    "description": "Iconic Essence Push Button Assembly, Fan, Artic White ",
    "name": "Pushbutton Fan Controller",
    "image": "E40APBF-AW.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40APBF-AG",
    "description": "Iconic Essence Push Button Assembly, Fan, Ash Grey",
    "name": "Pushbutton Fan Controller",
    "image": "E40APBF-AG.png",
    "category": "Bluetooth",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40APF",
    "mechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "displayedMechs": [
      "41ECSFWM-VW",
      "41ECSFWMZ-VW"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40SPK/2-TN",
    "description": "Clipsal Iconic Audio Connector, RCA Socket Pair, Translucent",
    "name": "RCA Audio RD+BK",
    "image": "40SPK_2-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "40SPK/2-TN (RD)",
      "40SPK/2-TN (BK)"
    ],
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40SPK/2-TN (RD)",
    "description": "Clipsal Iconic Audio Connector, RCA Socket Pair, Translucent (RD)",
    "name": "RCA Audio RD",
    "image": "40SPK_2-TN-RD.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40SPK/2-TN (BK)",
    "description": "Clipsal Iconic Audio Connector, RCA Socket Pair, Translucent (BK)",
    "name": "RCA Audio BK",
    "image": "40SPK_2-TN-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM3KB-CE",
    "description": "Clipsal Iconic Styl Knob Kit Rotary, Off-1-2-3, Crowne",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-CE.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM3KB-SV",
    "description": "Clipsal Iconic Styl Kit Knob Rotary, Off-1-2-3, Silver",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-SV.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM3KB-SH",
    "description": "Clipsal Iconic Styl Kit Knob Rotary, Off-1-2-3, Silver Shadow",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "S40RSM3KB-SH.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM3KB",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-2-3, 4 Colours",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "40RSM3KB (VW)",
      "40RSM3KB (WY)",
      "40RSM3KB (CY)",
      "40RSM3KB (AN)"
    ],
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM3KB (VW)",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (VW)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-VW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM3KB (WY)",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (WY)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-WY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM3KB (CY)",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (CY)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-CY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM3KB (AN)",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black (AN)",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "40RSM3KB-AN.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40RSM3",
    "mechs": [
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM2KB-CE",
    "description": "Clipsal Iconic Styl Knob Kit Rotary, Off-1-Off-2, Crowne",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "S40RSM2KB-CE.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM2KB-SV",
    "description": "Clipsal Iconic Styl Knob Rotary, Off-1-Off-2, Silver",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "S40RSM2KB-SV.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40RSM2KB-SH",
    "description": "Clipsal Iconic Styl Knob Rotary, Off-1-Off-2, Silver Shadow",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "S40RSM2KB-SH.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM2KB",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-0-2, 4 Colours",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": [
      "40RSM2KB (VW)",
      "40RSM2KB (CY)",
      "40RSM2KB (AN)"
    ],
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM2KB (VW)",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-0-2, 4 Colours (VW)",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-VW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM2KB (WY)",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-0-2, 4 Colours (WY)",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-WY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM2KB (CY)",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-0-2, 4 Colours (CY)",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-CY.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RSM2KB (AN)",
    "description": "Clipsal Iconic Rotary Switch Knob Kit, 4-Position 0-1-0-2, 4 Colours (AN)",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-AN.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40RSM2",
    "mechs": [
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40SR-VW",
    "description": "Clipsal Iconic Sensor Rocker, Vivid White, 10 Pack",
    "name": "Sensor",
    "image": "40SR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40SR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-AG",
    "description": "Clipsal Iconic Mechanism Cap, Single USB Charger, 5 Pack",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E1USBCAP",
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-AN",
    "description": "Clipsal Iconic USB Mechanism Cap, Single USB Charger, Anthracite, 5 Pack",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E1USBCAP",
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-CY",
    "description": "Clipsal Iconic USB Mechanism Cap, Single USB Charger, 5 Pack",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E1USBCAP",
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-VW",
    "description": "Clipsal Iconic USB Mechanism Cap, Single USB Charger, 5 Pack, Vivid White",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E1USBCAP",
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-WY",
    "description": "Clipsal Iconic USB Mechanism Cap, Single USB Charger, 5 Pack",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E1USBCAP",
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 5,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40HDMIA-TN",
    "description": "Clipsal Iconic HDMI Adaptor, Angled, Translucent",
    "name": "Socket HDMI Angled",
    "image": "40HDMIA-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40HDMIS-TN",
    "description": "Clipsal Iconic HDMI Adaptor, Straight, Translucent",
    "name": "Socket HDMI Straight",
    "image": "40HDMIS-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40PFM-TN",
    "description": "Clipsal Iconic TV Antenna Socket, F-Type, Translucent",
    "name": "Socket TV F Type - F Type 3GHz",
    "image": "40PFM-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40FFPMS-TN",
    "description": "Clipsal Iconic TV Antenna Socket, F-Type Rear, Translucent",
    "name": "Socket TV PAL - F Type",
    "image": "40FFPMS-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40STR-AW",
    "description": "Clipsal Iconic Essence Rocker, STUDY, Arctic White",
    "name": "Study",
    "image": "E40STR-AW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AW",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "E40STR-AG",
    "description": "Clipsal Iconic Essence Rocker, STUDY, Ash Grey",
    "name": "Study",
    "image": "E40STR-AG.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40STR-VW",
    "description": "Clipsal Iconic Study Rocker, Vivid White, 10 Pack",
    "name": "Study",
    "image": "40STR-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40STR-CE",
    "description": "Clipsal Iconic Styl Rocker, STUDY, Crowne",
    "name": "Study",
    "image": "S40STR-CE.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "CE",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40STR-SV",
    "description": "Clipsal Iconic Styl Rocker, STUDY, Silver",
    "name": "Study",
    "image": "S40STR-SV.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SV",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "S40STR-SH",
    "description": "Clipsal Iconic Styl Rocker, STUDY, Silver Shadow",
    "name": "Study",
    "image": "S40STR-SH.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Styl",
    "color": "SH",
    "baseItemNo": "40STR",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-AG",
    "description": "Clipsal Iconic Rocker, 3 Position, Ash Grey",
    "name": "Toggle 3-Position",
    "image": "49T-AG.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-AN",
    "description": "Clipsal Iconic Rocker Toggle, 3-Position, Anthracite, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-AN.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-CY",
    "description": "Clipsal Iconic Rocker Toggle, 3-Position, Cool Grey, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-CY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-VW",
    "description": "Clipsal Iconic Rocker Toggle, 3-Position, Vivid White, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-XB",
    "description": "Dolly Toggle 3-pos BLANK Pck 10",
    "name": "Toggle 3-Position",
    "image": "P49TAOM-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49T-WY",
    "description": "Clipsal Iconic Rocker Toggle, 3-Position, Warm Grey, Blank, 10 Pack",
    "name": "Toggle 3-Position",
    "image": "49T-WY.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "49T",
    "mechs": [
      "49M-VW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "49MLBL-VW",
    "description": "Clipsal Iconic Rocker Toggle, 3-Position, Marked SON -AOM-UOD, Vivid White, 3 Pack",
    "name": "Toggle SON-AOM-UOD",
    "image": "49MLBL-VW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "49MLBL",
    "mechs": [
      "49M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40Z1R-VW",
    "description": "Clipsal Iconic Zone 1 Rocker, Vivid White, 10 Pack",
    "name": "Zone 1",
    "image": "40Z1R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40Z1R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40Z2R-VW",
    "description": "Clipsal Iconic Zone 2 Rocker, Vivid White, 10 Pack",
    "name": "Zone 2",
    "image": "40Z2R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40Z2R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "40Z3R-VW",
    "description": "Clipsal Iconic Zone 3 Rocker, Vivid White, 10 Pack",
    "name": "Zone 3",
    "image": "40Z3R-VW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40Z3R",
    "mechs": [
      "40M",
      "40USM",
      "40MBPRL-VW",
      "40MD20",
      "40MIL"
    ],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "48HD-TN",
    "description": "Clipsal Iconic Permanent Connection Unit (PCU)",
    "name": "Permanent Connection Unit (PCU)",
    "image": "48HD-TN.png",
    "category": "Accessories",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCAP-BK",
    "description": "Clipsal Iconic USB Mechanism Cap, Single USB Charger Type A, Black",
    "name": "Single USB Type-A",
    "image": "40E1USBCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [
      "40E1USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "40E2USBACCAP-BK",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger Type A+C, Black",
    "name": "Dual USB Type-A + Type C",
    "image": "40E2USBACCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [
      "40E2USBACM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "40E2USBCAP-BK",
    "description": "Clipsal Iconic USB Mechanism Cap, Dual USB Charger Type A+A, Black",
    "name": "Dual USB Type-A",
    "image": "40E2USBCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [
      "40E2USBM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "40ADPKS-TN",
    "description": "Adaptor RJ Tyco KrOne Siemon, 10Pk.",
    "name": "Adaptor RJ Tyco KrOne Siemon",
    "image": "PDL319MKC-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 10,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40N-GR",
    "description": "Clipsal Iconic LED Mechanism, Green 250V",
    "name": "LED Mechanism, Green 250V",
    "image": "40N-GR.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40N-RD",
    "description": "Clipsal Iconic LED Mechanism, Red 250V",
    "name": "LED Mechanism, Red 250V",
    "image": "40N-RD.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40N24-GR",
    "description": "Clipsal Iconic LED Mechanism, Green 24V",
    "name": "LED Mechanism, Green 24V",
    "image": "40N24-GR.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40N24-RD",
    "description": "Clipsal Iconic LED Mechanism, Red 24V",
    "name": "LED Mechanism, Red 24V",
    "image": "40N24-RD.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40NPA-AM",
    "description": "Clipsal Iconic LED Mechanism, Marked Power Available, Amber 250V",
    "name": "Marked Power Available, Amber 250V",
    "image": "40NPA-AM.png",
    "category": "LED",
    "subcategory": null,
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40AR-BK",
    "description": "Clipsal Pro BLANK Rocker, Black",
    "name": "Standard",
    "image": "40AR-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40AR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40AR-XW",
    "description": "Clipsal Pro BLANK Rocker, White",
    "name": "Standard",
    "image": "P40AR-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40AR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40ACR-BK",
    "description": "Clipsal Pro Air Conditioner Rocker, Black",
    "name": "Airconditioner",
    "image": "40ACR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40ACR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40ACR-XW",
    "description": "Clipsal Pro Air Conditioner Rocker, White",
    "name": "Airconditioner",
    "image": "40ACR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40ACR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40ALR-BK",
    "description": "Clipsal Pro ALARM Rocker, Black",
    "name": "Alarm",
    "image": "40ALR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40ALR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40ALR-XW",
    "description": "Clipsal Pro ALARM Rocker, White",
    "name": "Alarm",
    "image": "40ALR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40ALR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40APB-BK",
    "description": "Clipsal Pro Push button, Black",
    "name": "Push button ",
    "image": "P40APB-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40APB",
    "mechs": [
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW",
      "41E300PBUD2SM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW"
    ],
    "displayedMechs": [
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40APB-XW",
    "description": "Clipsal Pro Push button, White",
    "name": "Push button ",
    "image": "P40APB-XW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40APB",
    "mechs": [
      "41E300PBUD2SM-VW",
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBM-VW",
      "5041NMML",
      "5041NMS",
      "41EPBCLM-VW"
    ],
    "displayedMechs": [
      "41EPBM-VW",
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW",
      "41EPBCLM-VW",
      "5041NMML",
      "5041NMS"
    ],
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40FR-BK",
    "description": "Clipsal Pro FAN Rocker, Black",
    "name": "Fan",
    "image": "40FR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RF",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40FR-XW",
    "description": "Clipsal Pro FAN Rocker, White",
    "name": "Fan",
    "image": "40FR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40RF",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40FRR-BK",
    "description": "Clipsal Pro FRIDGE Rocker, Black",
    "name": "Fridge",
    "image": "40FRR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40FRR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40FRR-XW",
    "description": "Clipsal Pro FRIDGE Rocker, White",
    "name": "Fridge",
    "image": "P40FRR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40FRR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40HR-BK",
    "description": "Clipsal Pro HEAT Rocker, Black",
    "name": "Heat",
    "image": "40HR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RH",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40HR-XW",
    "description": "Clipsal Pro HEAT Rocker, White",
    "name": "Heat",
    "image": "40HR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40RH",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40HWR-BK",
    "description": "Clipsal Pro HOT WATER Rocker, Black",
    "name": "Hot Water",
    "image": "40HWR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40HWR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40HWR-XW",
    "description": "Clipsal Pro HOT WATER Rocker, White",
    "name": "Hot Water",
    "image": "40HWR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40HWR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40LOCKR-BK",
    "description": "Clipsal Pro Locking BLANK Rocker, Black",
    "name": "Standard Locking",
    "image": "P40LOCKR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40LOCKR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40LOCKR-XW",
    "description": "Clipsal Pro Locking BLANK Rocker, White",
    "name": "Standard Locking",
    "image": "P40LOCKR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40LOCKR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40LR-BK",
    "description": "Clipsal Pro LIGHT Rocker, Black",
    "name": "Light",
    "image": "P40LR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40LR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40LR-XW",
    "description": "Clipsal Pro LIGHT Rocker, White",
    "name": "Light",
    "image": "40LR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40LR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R20COOK-BK",
    "description": "Clipsal Pro COOKER Rocker, 20A, Black",
    "name": "20Amp Cooker",
    "image": "P40R20COOK-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40R20COOK",
    "mechs": [
      "40MD20COOK-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R20COOK-XW",
    "description": "Clipsal Pro COOKER Rocker, 20A, White",
    "name": "20Amp Cooker",
    "image": "P40R20COOK-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40R20COOK",
    "mechs": [
      "40MD20COOK-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R32-BK",
    "description": "Clipsal Pro 32A Rocker, Black",
    "name": "32Amp Standard",
    "image": "P40R32-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R32-XW",
    "description": "Clipsal Pro 32A Rocker, White",
    "name": "32Amp Standard",
    "image": "P40R32-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40R32",
    "mechs": [
      "40M32-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R32COOK-BK",
    "description": "Clipsal Pro COOKER Rocker, 32A, Black",
    "name": "32Amp Cooker",
    "image": "P40R32COOK-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40R32COOK",
    "mechs": [
      "P40M32COOK-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40R32COOK-XW",
    "description": "Clipsal Pro COOKER Rocker, 32A, White",
    "name": "32Amp Cooker",
    "image": "P40R32COOK-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40R32COOK",
    "mechs": [
      "P40M32COOK-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40SR-BK",
    "description": "Clipsal Pro SENSOR Rocker, Black",
    "name": "Sensor",
    "image": "40SR-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40SR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40SR-XW",
    "description": "Clipsal Pro SENSOR Rocker, White",
    "name": "Sensor",
    "image": "40SR-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40SR",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z1R-BK",
    "description": "Clipsal Pro ZONE 1 Rocker, Black",
    "name": "Zone 1 ",
    "image": "40Z1R-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40Z1R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z1R-XW",
    "description": "Clipsal Pro ZONE 1 Rocker, White",
    "name": "Zone 1",
    "image": "40Z1R-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40Z1R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z2R-BK",
    "description": "Clipsal Pro ZONE 2 Rocker, Black",
    "name": "Zone 2",
    "image": "40Z2R-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40Z2R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z2R-XW",
    "description": "Clipsal Pro ZONE 2 Rocker, White",
    "name": "Zone 2",
    "image": "40Z2R-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40Z2R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z3R-BK",
    "description": "Clipsal Pro ZONE 3 Rocker, Black",
    "name": "Zone 3",
    "image": "40Z3R-BK.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40Z3R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40Z3R-XW",
    "description": "Clipsal Pro ZONE 3 Rocker, White",
    "name": "Zone 3",
    "image": "40Z3R-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40Z3R",
    "mechs": [
      "40USM",
      "40M",
      "P40MBPR-XW",
      "P40MD10",
      "P40MD20",
      "40MI"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40CSFM-XW",
    "description": "Clipsal Pro Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor 75VA",
    "name": "Fan Speed Controller",
    "image": "P40CSFM-XW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40CSFM",
    "mechs": [
      "P40CSFM-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40B-TN",
    "description": "Clipsal Pro Blank Mechanism Adaptor, PK5, Translucent",
    "name": "Standard Adaptor",
    "image": "P40-TN.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": null,
    "color": null,
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40B-XW",
    "description": "Clipsal Pro Blank Mechanism Adaptor, PK5, White",
    "name": "Standard Adaptor",
    "image": "P40B-XW.png",
    "category": "Switches",
    "subcategory": "Pictogram Rockers",
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40EDIMKB-BK",
    "description": "Clipsal Pro Rotary Dimmer Knob Parts Pack, Black",
    "name": "Rotary Dimmer",
    "image": "P40EDIMKB-BK.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40EDIMKB-XW",
    "description": "Clipsal Pro Rotary Dimmer Knob Parts Pack, White",
    "name": "Rotary Dimmer",
    "image": "P40EDIMKB-XW.png",
    "category": "Dimmers",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40EDIMKB",
    "mechs": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P40MLEDBW-BK",
    "description": "Clipsal Pro LED Module,250V Bright White with Black Rocker",
    "name": "LED Module 250V ",
    "image": "P40MLEDBW-BK.png",
    "category": "LED",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40MLEDBW",
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40MLEDBW-XW",
    "description": "Clipsal Pro LED Module,250V Bright White with White Rocker",
    "name": "LED Module 250V ",
    "image": "P40MLEDBW-XW.png",
    "category": "LED",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "40MLEDBW",
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40RSM2-XW",
    "description": "Clipsal Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "40RSM2KB-VW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40RSM2",
    "mechs": [
      "P40RSM2-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40RSM2KB-BK",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-0-2, Black",
    "name": "Rotary Knob OFF-1-OFF-2",
    "image": "P40RSM2KB-BK.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RSM2KB",
    "mechs": [
      "P40RSM2-XW",
      "40RSM2-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40RSM3-XW",
    "description": "Clipsal Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "P40RSM3-XW.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "P40RSM3",
    "mechs": [
      "P40RSM3-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": false
  },
  {
    "itemNo": "P40RSM3KB-BK",
    "description": "Clipsal Pro Rotary Switch Knob Kit, 4-Position 0-1-2-3, Black",
    "name": "Rotary Knob OFF-1-2-3",
    "image": "P40RSM3KB-BK.png",
    "category": "Rotary Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "40RSM3KB",
    "mechs": [
      "P40RSM3-XW",
      "40RSM3-VW",
      "40CSFM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49T-BK",
    "description": "Clipsal Pro Rocker Toggle 3-pos BLANK",
    "name": "Toggle 3-Position",
    "image": "P49T-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "49T",
    "mechs": [
      "P49M-XW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49T-XW",
    "description": "Clipsal Pro Rocker Toggle 3-pos BLANK",
    "name": "Toggle 3-Position",
    "image": "P49T-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49T",
    "mechs": [
      "P49M-XW",
      "P49MBPR-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TAOM-BK",
    "description": "Clipsal Pro Rocker Toggle 3-pos AUTO-OFF-MANUAL",
    "name": "Toggle SON-AOM-UOD",
    "image": "P49TAOM-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "49TAOM",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TAOM-XW",
    "description": "Clipsal Pro Rocker Toggle 3-pos AUTO-OFF-MANUAL",
    "name": "Toggle SON-AOM-UOD",
    "image": "P49TAOM-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TAOM",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TSOO-BK",
    "description": "Clipsal Pro Rocker Toggle 3-pos SENSOR-ON-OFF",
    "name": "Toggle Sensor-On-Off",
    "image": "P49TSOO-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "49TSOO",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TSOO-XW",
    "description": "Clipsal Pro Rocker Toggle 3-pos SENSOR-ON-OFF",
    "name": "Toggle Sensor-On-Off",
    "image": "P49TSOO-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TSOO",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TUOD-BK",
    "description": "Clipsal Pro Rocker Toggle 3-pos UP - OFF - DOWN",
    "name": "Toggle Up-Off-Down",
    "image": "P49TUOD-BK.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": "49TUOD",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "P49TUOD-XW",
    "description": "Clipsal Pro Rocker Toggle 3-pos UP - OFF - DOWN",
    "name": "Toggle Up-Off-Down",
    "image": "P49TUOD-XW.png",
    "category": "Switches",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": "49TUOD",
    "mechs": [
      "P49M-XW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": true,
    "proCompatible": false,
    "disableLedSupport": true
  },
  {
    "itemNo": "40E1USBCCAP-CY",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-CY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "CY",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-AG",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-AG.png",
    "category": "USB",
    "subcategory": null,
    "style": "Essence",
    "color": "AG",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-AN",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-AN.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "AN",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-BK",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-BK.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "XB",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-WY",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-WY.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "WY",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40E1USBCCAP-VW",
    "description": "Clipsal Iconic - Mechanism Cap USB Type C",
    "name": "USB Type C Fast Charger",
    "image": "40E1USBCCAP-VW.png",
    "category": "USB",
    "subcategory": null,
    "style": "Iconic",
    "color": "VW",
    "baseItemNo": "40E1USBCCAP",
    "mechs": [
      "40E1USBCM-VW"
    ],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6AC-BK",
    "description": "RJ45 JACK CAT6A UTP 40M BLACK (Iconic/Pro Series).",
    "name": "RJ45 JACK CAT6A UTP 40M",
    "image": "40RJ45SMA6AC-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ45SMA6AC-XW",
    "description": "RJ45 JACK CAT6A UTP 40M Extra white (Iconic/Pro Series).",
    "name": "RJ45 JACK CAT6A UTP 40M",
    "image": "40RJ45SMA6C-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ64SMT-BK",
    "description": "Clipsal Iconic Data Socket, Category 3, 4 Contact, Telephone, Black",
    "name": "Data Socket, Category 3, 4 Contact, Telephone",
    "image": "40RJ45SMA6C-BK.png",
    "category": "Network",
    "subcategory": null,
    "style": "Pro",
    "color": "ProBK",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  },
  {
    "itemNo": "40RJ64SMT-XW",
    "description": "Clipsal Iconic Data Socket, Category 3, 4 Contact, Telephone, Vivid White",
    "name": "Data Socket, Category 3, 4 Contact, Telephone",
    "image": "40RJ64SMT-TN.png",
    "category": "Network",
    "subcategory": null,
    "style": "Pro",
    "color": "ProXW",
    "baseItemNo": null,
    "mechs": [],
    "displayedMechs": null,
    "packQuantity": 1,
    "includedComponents": null,
    "pro": false,
    "proCompatible": true,
    "disableLedSupport": false
  }
]

const MechProducts: readonly MechProduct[] = 
[
  {
    "itemNo": "40CSFM-VW",
    "description": "Clipsal Iconic Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor, 5 Colour Options",
    "displayName": "Fan Controller Off-1-2-3",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40RSM3KB (VW)",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40E1USBM-VW",
    "description": "Clipsal Iconic Single USB Charging Mechanism, 1.5 A, Horizontal/Vertical Mount, Vivid White",
    "displayName": "USB Charging mech 1.5A",
    "image": "40E1USBM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40E1USBCAP-VW",
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40E2USBM-VW",
    "description": "Clipsal Iconic Dual USB Charging Mechanism 3.1 A, Horizontal/Vertical Mount, Vivid White",
    "displayName": "USB Charging mech Dual 3.1A",
    "image": "40E2USBM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40E2USBCAP-VW",
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40E2USBACM-VW",
    "description": "Clipsal Iconic Dual USB Charging Mechanism A+C, 15W",
    "displayName": "Dual USB charging mechanism (deep) 3.1A Type A + Type C",
    "image": "40E2USBACM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40E2USBACCAP-VW",
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40M",
    "description": "Clipsal Iconic Switch Mechanism, 1-Way/2-Way, 250V,10AX",
    "displayName": "Switch mech 10 amp",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40ML",
    "description": "Clipsal Iconic Switch Mechanism, 1-Way/2-Way, 250V, 10AX, LED",
    "displayName": "Switch mech 10 amp with LED",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40M32-VW",
    "description": "Clipsal Iconic Switch Mechanism, 1-Way, 250V,32A, Vivid White",
    "displayName": "Switch mech 32 amp",
    "image": "40M32-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40R32-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40MBPRL-VW",
    "description": "Clipsal Iconic Switch Mechanism, Bell Press Return, LED, 250V, 10A, Vivid White",
    "displayName": "Bell press mech with LED",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": "40AMR-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40MD20",
    "description": "Clipsal Iconic Switch Mechanism, 1-Way, Double Pole, 20AX",
    "displayName": "Switch mech 20 amp double pole",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40MIL",
    "description": "Clipsal Iconic Switch Mechanism, Intermediate, 250V, 10AX, 1-Way/2-Way, LED",
    "displayName": "Switch mech intermediate 10amp LED",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "Intermediate",
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40RSM2-VW",
    "description": "Clipsal Iconic Switch Mechanism, 4-Position, 250V, 10A, OFF -1-OFF-2 Vivid White ",
    "displayName": "4 Position Rotary Knob OFF-1-OFF-1",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40RSM2KB (VW)",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40RSM3-VW",
    "description": "Clipsal Iconic Rotary Switch Mechanism, 4-Position, 250V, 10A",
    "displayName": "4 Position Rotary Knob OFF-1-2-3",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40RSM3KB (VW)",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40USM",
    "description": "Clipsal Iconic Switch Mechanism, Universal Rocker, 250 V,20 A/16 AX, 1-Way/2-Way",
    "displayName": "Switch mech universal 20A/16AX",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41E300PBUD2SM-VW",
    "description": "Clipsal Iconic Universal Dimmer Mechanism, Pushbutton with ControlLink, 300 W, LED, Vivid White",
    "displayName": "Pushbutton Universal Dimmer 300W 2-wire with ControlLink",
    "image": "41E300PBUD2SM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41E10PBSWM-VW",
    "description": "Clipsal Iconic Push Button Wiser Switch Mechanism, 10A, ControlLink, 3-Wire",
    "displayName": "Wiser Push-Button Switch",
    "image": "41E10PBSWM-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 10A, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41E2PBSWM-VW",
    "description": "Iconic Connected Switch, 2AX, 240V, Vivid White",
    "displayName": "Wiser Switch 2A",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 2A",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41EPBDWCLM-VW",
    "description": "Clipsal Iconic Wiser Push-Button LED Dimmer",
    "displayName": "Wiser Dimmer, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "Wiser Dimmer, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41ECSFWM-VW",
    "description": "Iconic connected fan controller BLE",
    "displayName": "Wiser Fan Controller",
    "image": "41ECSFWM-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APBF-VW",
    "interfaceDisplayNameOverride": "Wiser Fan Controller",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/BLE (Bluetooth)",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41E10PBSWMZ-VW",
    "description": "Iconic Connected Switch, Zigbee Default Mode ControlLink, 300 W, 240 V, Vivid White",
    "displayName": "Wiser Switch 10A, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 10A, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41E2PBSWMZ-VW",
    "description": "Iconic Connected Switch, Zigbee Default Mode 2AX, 240V, Vivid White",
    "displayName": "Wiser Switch 2A",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "Wiser Switch 2A",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41EPBDWCLMZ-VW",
    "description": "Iconic Connected Dimmer, Zigbee Default Mode ControlLink, 300 W, 240 V, Vivid White",
    "displayName": "Wiser Dimmer, with ControlLink",
    "image": "",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "Wiser Dimmer, with ControlLink",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41ECSFWMZ-VW",
    "description": "Iconic connected fan controller Zigbee",
    "displayName": "Wiser Fan Controller",
    "image": "41ECSFWMZ-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APBF-VW",
    "interfaceDisplayNameOverride": "Wiser Fan Controller",
    "category": "Bluetooth",
    "subcategory": "Wiser Push Button Switches/Zigbee",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41EPBCLM-VW",
    "description": "Clipsal Iconic Smart PB Remote Mechanism with CTL and LED",
    "displayName": "ControlLink Remote Switch LED",
    "image": "41EPBCLM-VW.png",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "ControlLink Remote Switch LED",
    "category": "Bluetooth",
    "subcategory": "Remote Push Button Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "41EPBM-VW",
    "description": "Clipsal Iconic ControlLink Remote Switch Mechanism, Momentary Pushbutton, Vivid White",
    "displayName": "ControlLink Remote Switch",
    "image": "41EPBM-VW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": "40APB-VW",
    "interfaceDisplayNameOverride": "ControlLink Remote Switch",
    "category": "Bluetooth",
    "subcategory": "Remote Push Button Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "49M-VW",
    "description": "Clipsal Iconic Switch Mechanism, 3-Position Toggle, 250V, 10A, Vivid White",
    "displayName": "3 position toggle switch",
    "image": "49M-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "49T-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "42ELEDM2-VW",
    "description": "Clipsal Iconic Dimmer Mechanism, LED, Rotary, 220-240V, 150W, vivid white, 40 series",
    "displayName": "Rotary LED Dimmer 150W",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40EDIMKB-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "42E350RUD2M-VW",
    "description": "Clipsal Iconic Universal Dimmer Mechanism, Rotary, 350 W,Vivid White",
    "displayName": "Rotary Universal Dimmer 350W 2-wire",
    "image": "42E350RUD2M-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "40EDIMKB-VW",
    "interfaceDisplayNameOverride": null,
    "category": "Dimmers",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "5041NMML",
    "description": "C-Bus 40 SERIES MASTER MODULE",
    "displayName": "C-Bus 40 Series Master Module",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": "40EDIMKB-VW",
    "interfaceDisplayNameOverride": "C-Bus 40 Series Master Module",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "5041NMS",
    "description": "C-Bus 40 SERIES SLAVE MODULE",
    "displayName": "C-Bus 40 Series Slave Module",
    "image": "",
    "supportsLed": true,
    "includesLed": true,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": "C-Bus 40 Series Slave Module",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches",
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "P40CSFM-XW",
    "description": "Clipsal Pro Fan Speed Controller, 4-Position, Rotary Switch, Off-1-2-3, Capacitor 75VA",
    "displayName": "Fan Controller Off-1-2-3",
    "image": "P40CSFM-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P40CSFM-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40M32COOK-XW",
    "description": "Clipsal Pro Switch Mechanism, Cooker, 1-Way, 250V, 32A",
    "displayName": "Cooker mech",
    "image": "P40M32COOK-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P40R32COOK-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "40MD20COOK-VW",
    "description": "Clipsal Iconic Switch Mechanism, Cooker, 1-Way, Double Pole, 250V, 20AX, Vivid White",
    "displayName": "Cooker mech double pole",
    "image": "40MD20COOK-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "40M32COOK-VW",
    "description": "Clipsal Iconic Switch Mechanism, Cooker, 1-Way, 250V, 32A, Vivid White",
    "displayName": "Cooker mech",
    "image": "40M32COOK-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40MBPR-XW",
    "description": "Clipsal Pro Switch Mechanism, Bell Press Return, 250V, 10A",
    "displayName": "Bell press return",
    "image": "P40MBPR-XW.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40MD10",
    "description": "Clipsal Pro Switch Mechanism, 1-Way, Double Pole, 250V, 10AX",
    "displayName": "Double pole mech 10AX",
    "image": "P40MD10.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40MD20",
    "description": "Clipsal Pro Switch Mechanism, 1-Way, Double Pole, 250V, 20AX",
    "displayName": "Double pole mech 20 AX",
    "image": "",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40RSM2-XW",
    "description": "Clipsal Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "displayName": "4 Position Rotary Knob OFF-1-OFF-1",
    "image": "40RSM2KB-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P40RSM2-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P40RSM3-XW",
    "description": "Clipsal Pro Switch Mechanism, 4-Position, 250V, 10A, White",
    "displayName": "4 Position Rotary Knob OFF-1-2-3",
    "image": "P40RSM3-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P40RSM3-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Rotary Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P49M-XW",
    "description": "Clipsal Pro Switch Mechanism, 3-Position, 10A, 250V",
    "displayName": "3 position mech ",
    "image": "P49M-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": true,
    "proCompatible": false
  },
  {
    "itemNo": "P49MBPR-XW",
    "description": "Clipsal Pro Switch Mechanism, 3-Position, Bell Press Return, 10A, 250V",
    "displayName": "3 position mech bell press",
    "image": "P49MBPR-XW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": "P49T-XW",
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40MI",
    "description": "Clipsal Iconic Switch Mechanism, Intermediate, 250V, 10AX, 1-Way/2-Way",
    "displayName": "Intermediate mech ",
    "image": "40MI.png",
    "supportsLed": true,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "Switches",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  },
  {
    "itemNo": "40E1USBCM-VW",
    "description": "Clipsal Iconic USB Fast charger, Type C, 25W, 240V",
    "displayName": "USB Fast Charger",
    "image": "40E1USBCM-VW.png",
    "supportsLed": false,
    "includesLed": false,
    "includedInterfaceItemNo": null,
    "interfaceDisplayNameOverride": null,
    "category": "USB",
    "subcategory": null,
    "pro": false,
    "proCompatible": false
  }
]

const ProductRules: readonly ProductRule[] = 
[
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 2,
    "orientation": "Both",
    "products": [
      "40E2USBM-VW",
      "40E2USBACM-VW",
      "40E1USBCM-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 2,
    "orientation": "Vertical",
    "products": [
      "40MD20COOK-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Horizontal",
    "products": [
      "40MD20COOK-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW"
    ]
  },
  {
    "ruleType": "SwitchOnly",
    "products": [
      "41EPIRM-TN"
    ]
  },
  {
    "ruleType": "RequiresOtherMech",
    "otherMechs": [
      "40M"
    ],
    "products": [
      "42ELEDM2-VW",
      "42E350RUD2M-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "40E1USBM-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 4,
    "orientation": "Both",
    "products": [
      "40HDMIA-TN"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "41EPIRM-TN"
    ]
  },
  {
    "ruleType": "ExclusiveCategory",
    "category": "Network",
    "subcategory": null
  },
  {
    "ruleType": "ExclusiveCategory",
    "category": "Bluetooth",
    "subcategory": "C-Bus Switches"
  },
  {
    "ruleType": "IncompatibleGrids",
    "incompatibleGrids": [
      "3042AL-VW",
      "PDL362G"
    ],
    "products": [
      "41E10PBSWM-VW",
      "41EPBDWCLM-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 2,
    "orientation": "Horizontal",
    "products": [
      "40M32-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "41E2PBSWMZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "41E10PBSWMZ-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "41E10PBSWMZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "41EPBDWCLMZ-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "41EPBDWCLMZ-VW"
    ]
  },
  {
    "ruleType": "MaxGangNo",
    "maxGangNumber": 3,
    "orientation": "Both",
    "products": [
      "41ECSFWMZ-VW",
      "41ECSFWM-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "3025CSGZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP5010WDZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "41EPBM-VW",
    "products": [
      "CLP5010WDZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP5011WSZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "41EPBM-VW",
    "products": [
      "CLP5011WSZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP5015WBZ"
    ]
  },
  {
    "ruleType": "RequiresMomentarySwitches",
    "overrideMech": "41EPBM-VW",
    "products": [
      "CLP5015WBZ"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP595011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP593011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP592011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP591011"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP501902_0001"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP501401"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "41ECSFWMZ-VW"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP599WSA"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "755WSA"
    ]
  },
  {
    "ruleType": "RequiresWiserHub",
    "products": [
      "CLP599WSAL"
    ]
  }
]

const ConstantProducts: ConstantProductsShape = {
  WiserHub: "CLP501902",
  WiserSwitchDefaultMech: "41E2PBSWMZ-VW",
}

const ClipsalProductData = { GridProducts, SkinProducts, InterfaceProducts, MechProducts, ProductRules, ConstantProducts }
export default ClipsalProductData